function SvgComponent(props) {
  return (
    <svg
      width={635}
      height={495}
      viewBox="0 0 635 495"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M308.915 189.168s-17.195 40.863 6.962 56.179c24.156 15.315 36.199-44.066 36.199-44.066l-43.161-12.113z"
        fill="#2D5ACC"
      />
      <path
        d="M369.27 155.549s-35.086.348-54.508 12.948c-19.422 12.6-5.917 73.791 3.063 107.136s40.307 8.632 40.307 8.632l26.592-5.012s20.954-7.449 22.346-8.005c1.323-.557 23.6-83.955-37.8-115.699z"
        fill="#2D5ACC"
      />
      <path
        d="M513.37 204.488c0 3.063-2.019 6.057-5.987 8.424l-142.778 82.144c-8.006 4.595-20.885 4.595-28.821 0l-47.129-27.01c-3.968-2.297-5.917-5.291-5.917-8.284l.14 84.512c0 2.993 1.949 5.986 5.917 8.284l47.129 27.01c7.936 4.595 20.884 4.595 28.82 0l142.778-82.145c4.038-2.297 6.057-5.36 5.987-8.423l-.139-84.512z"
        fill="#F8F8F8"
      />
      <path
        d="M431.504 169.274c8.006-4.595 20.884-4.595 28.82 0l47.129 27.01c7.936 4.595 7.866 12.113-.07 16.708l-142.778 82.144c-8.006 4.595-20.885 4.595-28.821 0l-47.128-27.01c-7.936-4.594-7.867-12.113.069-16.707l142.779-82.145z"
        fill="url(#paint0_linear_4171_3723)"
      />
      <path d="M364.257 183.473l-.557 7.24-8.632.556-2.785-6.543 11.974-1.253z" fill="#353535" />
      <path
        d="M361.124 188s3.551 18.1 10.512 29.656c6.962 11.556 8.423 11.486 8.423 11.486l-2.714 10.303-8.981-5.221s-13.226-42.047-12.043-45.945c1.253-3.899 4.803-.279 4.803-.279z"
        fill="#353535"
      />
      <path
        d="M406.789 179.778s-9.885 13.436-10.163 17.752l-18.03-8.911s5.082-14.758 9.676-15.733c4.525-.974 18.517 6.892 18.517 6.892z"
        fill="#2D5ACC"
      />
      <path
        d="M383.052 116.304s-12.391-28.681-20.327-30.561c-8.006-1.88-23.112 8.493-23.53 20.188-.348 11.695 43.857 10.373 43.857 10.373z"
        fill="#F0F0F0"
      />
      <path
        d="M374.211 114.486s-7.658-25.131-16.847-22.764c-9.189 2.367-13.923 12.113-13.923 12.113s14.132 14.41 30.77 10.651z"
        fill="#DEDEDE"
      />
      <path
        d="M387.019 168.437c9.258-15.454 1.74-27.985 1.74-27.985 3.55-9.467 1.81-14.967-1.531-20.954-5.57-10.024-16.081-15.245-16.081-15.245-12.6-6.892-23.182-7.38-31.884-5.43l-.069-.14s-2.367.766-3.133.975c-9.259 2.854-16.081 8.284-20.327 10.442-2.297 1.184-4.316 4.873-5.778 10.025-4.455 5.43-8.772 9.398-9.537 16.986-1.601 15.106 2.645 42.604 41.351 45.667 38.705 3.063 45.249-14.341 45.249-14.341z"
        fill="#F0F0F0"
      />
      <path
        d="M358.267 149.992l3.481-.139c1.392-.07 2.576 1.113 2.576 2.506 0 2.018-.696 4.455-3.759 4.594-2.785.07-4.038-1.949-4.595-3.759-.487-1.601.696-3.133 2.297-3.202z"
        fill="#353535"
      />
      <path
        d="M300.279 140.523s-9.328-23.739-5.291-30.213c4.038-6.404 21.998-11.208 30.63-5.43 8.633 5.778-25.339 35.643-25.339 35.643z"
        fill="#F0F0F0"
      />
      <path
        d="M304.945 133.561s-9.955-18.726-2.089-23.738c7.867-5.012 15.107-2.785 15.107-2.785s.835 17.056-13.018 26.523z"
        fill="#DEDEDE"
      />
      <path
        d="M382.357 153.4a.624.624 0 01-.627-.626c0-.348.279-.696.627-.696.07 0 5.43-.209 11.069-3.412.348-.208.765-.069.905.279.208.348.069.766-.279.905-5.987 3.411-11.486 3.55-11.695 3.62.07-.07 0-.07 0-.07zM384.653 158.48c-.627-.07-1.044-.139-1.044-.139-.348-.07-.627-.418-.557-.766.069-.348.417-.627.766-.557.069 0 5.36.835 11.555-1.183.349-.14.766.069.836.417.139.348-.07.766-.418.836a29.734 29.734 0 01-11.138 1.392zM339.055 156.053h-.069c-.209-.07-5.639-1.253-10.86-5.708-.279-.209-.348-.697-.07-.975.209-.279.696-.348.975-.07 4.942 4.177 10.233 5.361 10.303 5.43.348.07.626.418.487.836-.07.278-.418.557-.766.487zM336.271 160.643c-1.671-.139-6.265-.765-11.138-3.48a.705.705 0 01-.279-.905.705.705 0 01.905-.279c5.639 3.133 11.069 3.342 11.139 3.342.348 0 .696.348.696.696s-.348.696-.696.696c0-.07-.279-.07-.627-.07z"
        fill="#353535"
      />
      <path
        d="M312.604 234.708v.348c0 .07-.001.07.069.14 0 .069 0 .139.07.139 0 .069.069.069.069.139s.07.139.07.209c0 .069.07.069.07.139.069.07.069.139.139.209l.209.209.208.209.14.139c.069.069.139.069.209.139.069.07.139.07.139.139.069.07.209.14.278.209l61.33 35.364 89.942-52.21v2.645l-89.942 52.28-61.33-35.434c-.069-.069-.139-.069-.209-.139-.069 0-.069-.069-.069-.069-.07-.07-.139-.07-.209-.14-.07-.069-.139-.069-.209-.139l-.139-.139-.07-.07-.139-.139c-.07-.07-.139-.139-.139-.209v-.069c-.07-.07-.07-.14-.139-.209l-.07-.07c0-.069-.07-.139-.07-.209 0-.069-.069-.069-.069-.139 0-.069 0-.139-.07-.139 0-.07 0-.07-.069-.139v-.209-.139-2.646z"
        fill="url(#paint1_linear_4171_3723)"
      />
      <path
        d="M404.216 184.799c-2.228-1.323-5.848-1.323-8.075 0l-81.867 47.546c-2.227 1.323-2.227 3.411 0 4.664l61.33 35.364 89.942-52.141-61.33-35.433z"
        fill="#F8F8F8"
      />
      <path
        d="M391.617 207.562c-4.873 2.854-9.746 5.638-14.619 8.492-4.943 2.855-9.886 5.709-14.828 8.633-.975.557-1.393.557-2.367 0-.557-.348-9.259-5.639-9.816-5.987-.626-.348-1.253-.696-1.81-1.044-.835-.488-.835-.766 0-1.253 9.955-5.778 19.84-11.556 29.795-17.334.836-.488 1.323-.488 2.158 0l1.462.835c.627.348 9.398 5.708 10.025 6.056 1.253.766 1.253.905 0 1.602z"
        fill="url(#paint2_linear_4171_3723)"
      />
      <path
        d="M397.048 211.88c1.253.766 1.253.905 0 1.601-4.873 2.854-9.746 5.639-14.619 8.493-4.943 2.854-9.885 5.708-14.828 8.632-.975.557-1.392.557-2.367 0-.557-.348-1.114-.626-1.671-.975-.626-.348-1.253-.696-1.81-1.044-.835-.487-.835-.766 0-1.253 9.955-5.778 19.841-11.556 29.795-17.334.836-.487 1.323-.487 2.158 0l1.462.836 1.88 1.044z"
        fill="url(#paint3_linear_4171_3723)"
      />
      <path
        d="M425.937 195.588c.626.348.557.696 0 1.044-.627.348-1.323.766-1.95 1.114-.626.348-1.322.765-1.949 1.113-.626.349-1.253.349-1.879 0-.766-.417-1.462-.835-2.228-1.253-.557-.348-1.114-.626-1.671-.974-.626-.348-.626-.696-.069-1.044l3.968-2.298c.626-.348 1.253-.348 1.81 0 .696.418 1.461.836 2.158 1.253.626.348 1.253.697 1.81 1.045z"
        fill="url(#paint4_linear_4171_3723)"
      />
      <path
        d="M449.537 215.987c-.557-.348-.557-.697 0-1.045 1.322-.765 2.715-1.531 4.037-2.366a1.578 1.578 0 011.741 0c.278.139.557.278.835.487.418.209.836.487 1.184.696.417.209.835.487 1.253.696.278.139.487.279.765.487.557.348.557.697 0 .975-1.322.835-2.715 1.601-4.107 2.367a1.778 1.778 0 01-1.671 0c-.348-.209-.626-.348-.974-.557-1.044-.557-2.089-1.183-3.063-1.74z"
        fill="url(#paint5_linear_4171_3723)"
      />
      <path
        d="M456.148 212.09c-.557-.348-.557-.696 0-1.044.696-.418 1.323-.766 2.019-1.183.627-.348 1.253-.766 1.949-1.114.696-.418 1.184-.418 1.88 0 .696.348 1.322.766 1.949 1.114.626.348 1.253.696 1.88 1.113.696.418.696.697 0 1.114-1.254.766-2.576 1.462-3.829 2.228-.627.348-1.253.418-1.88 0-.418-.279-.835-.487-1.322-.766-.836-.348-1.741-.905-2.646-1.462z"
        fill="url(#paint6_linear_4171_3723)"
      />
      <path
        d="M438.955 196.843c-1.88 1.114-3.829 2.228-5.709 3.341-1.949 1.114-3.829 2.228-5.778 3.342-.974.557-1.392.557-2.297 0-.557-.348-1.114-.627-1.671-.975-.626-.348-1.253-.765-1.879-1.113-.836-.488-.836-.766 0-1.254 3.898-2.227 7.727-4.524 11.625-6.752.836-.487 1.393-.487 2.298 0 .487.278 1.044.557 1.531.905.627.348 1.253.766 1.949 1.114.905.626.905.835-.069 1.392z"
        fill="url(#paint7_linear_4171_3723)"
      />
      <path
        d="M431.436 202.269c.626-.348 1.253-.696 1.879-1.113.627-.348 1.323-.766 1.95-1.114.696-.418 1.253-.418 1.949 0 .418.278.905.487 1.322.766l1.045.626c.348.209.696.418.974.557.14.07.279.139.488.278.626.349.626.766 0 1.114-1.323.766-2.576 1.532-3.899 2.298-.626.348-1.253.348-1.81 0-1.044-.627-2.088-1.184-3.132-1.81-.279-.14-.557-.349-.836-.488-.626-.417-.557-.765.07-1.114z"
        fill="url(#paint8_linear_4171_3723)"
      />
      <path
        d="M452.459 204.499c-1.254.766-2.507 1.462-3.76 2.158-.765.418-1.253.418-1.949 0-.696-.417-1.392-.765-2.088-1.183-.557-.348-1.184-.696-1.741-1.044-.696-.418-.696-.696 0-1.114.766-.557.766-.557-.069-1.044-.209-.14-.418-.209-.627-.348-.417-.209-.835-.488-1.253-.697-.348-.208-.626-.348-.974-.556-.627-.349-1.184-.697-1.81-1.045-.766-.417-.766-.696 0-1.183.626-.348 1.183-.696 1.81-1.044.835-.488 1.322-.488 2.158 0 .765.417 1.462.835 2.227 1.253l2.924 1.67c.209.14.348.209.557.349.348.208.766.417 1.114.626l1.462.835c.696.418 1.392.836 2.088 1.184.696.418.696.696-.069 1.183z"
        fill="url(#paint9_linear_4171_3723)"
      />
      <path
        d="M430.392 203.801c.279.139.557.278.766.418.418.209.835.487 1.253.696.418.209.835.487 1.253.696.279.139.557.348.835.487.557.348.557.627 0 .975-1.322.766-2.645 1.601-4.037 2.367a1.58 1.58 0 01-1.74 0c-.627-.348-1.184-.696-1.81-1.044-.766-.418-1.532-.905-2.298-1.323-.557-.279-.626-.627-.069-.975 1.392-.835 2.784-1.601 4.177-2.436.556-.139 1.183-.139 1.67.139z"
        fill="url(#paint10_linear_4171_3723)"
      />
      <path
        d="M444.036 206.103c.626.348 1.253.766 1.879 1.114.627.348.557.696 0 1.044-.626.348-1.323.766-1.949 1.114-.627.348-1.253.766-1.88 1.114-.765.418-1.253.418-1.949 0l-1.462-.835-2.506-1.462c-.626-.348-.626-.766 0-1.114 1.253-.766 2.576-1.462 3.829-2.228.626-.348 1.253-.417 1.879 0 .766.488 1.462.905 2.159 1.253z"
        fill="url(#paint11_linear_4171_3723)"
      />
      <path
        d="M459.073 208.33c-1.184.696-2.298 1.323-3.481 2.019-1.183.696-2.297 1.392-3.481 2.019-.835.487-1.322.487-2.158 0-.557-.348-1.183-.627-1.74-.975-.627-.348-1.253-.766-1.949-1.114-.766-.487-.766-.766 0-1.253 2.297-1.392 4.664-2.715 6.961-4.037.766-.488 1.323-.488 2.089 0l1.879 1.044 1.88 1.044c.835.557.835.766 0 1.253z"
        fill="url(#paint12_linear_4171_3723)"
      />
      <path
        d="M449.257 212.993c.626.348.626.766 0 1.114-.627.348-1.323.766-1.949 1.114-.627.348-1.254.766-1.88 1.114-.766.417-1.253.417-1.949 0-.488-.279-.905-.557-1.393-.766-.278-.209-.626-.348-.905-.557a15.653 15.653 0 00-1.113-.626c-.14-.07-.279-.14-.488-.279-.626-.348-.696-.766-.069-1.114 1.322-.766 2.575-1.531 3.898-2.297.627-.348 1.253-.418 1.949 0 .627.348 1.323.766 1.95 1.114.626.417 1.253.835 1.949 1.183z"
        fill="url(#paint13_linear_4171_3723)"
      />
      <path
        d="M358.968 242.231c-.627-.348-1.253-.696-1.88-1.114-.696-.417-1.392-.835-2.088-1.183-.557-.348-.557-.696 0-1.044 1.322-.766 2.645-1.601 4.037-2.367.557-.348 1.184-.279 1.741 0 .278.139.557.348.905.487.417.209.765.418 1.183.696.418.209.835.488 1.184.696.278.14.487.279.765.418.627.348.557.696 0 1.044l-3.968 2.298c-.626.417-1.253.417-1.879.069z"
        fill="url(#paint14_linear_4171_3723)"
      />
      <path
        d="M349.569 240.004c.627.348.627.696 0 1.045-1.322.765-2.575 1.531-3.898 2.297-.626.348-1.253.348-1.88 0-.208-.139-.417-.279-.626-.348-.418-.279-.835-.488-1.323-.766-.417-.278-.905-.487-1.322-.766-.209-.139-.418-.278-.627-.348-.626-.348-.626-.696-.07-1.044l3.968-2.297c.627-.348 1.253-.348 1.81 0 .488.278.905.557 1.393.765.835.488 1.67.975 2.575 1.462z"
        fill="url(#paint15_linear_4171_3723)"
      />
      <path
        d="M352.284 233.875c.279.139.488.278.766.417.418.209.836.488 1.184.696.417.279.905.488 1.322.766.209.139.418.279.696.348.627.348.557.696 0 1.044-1.322.766-2.575 1.532-3.898 2.298-.696.417-1.183.417-1.949 0-.627-.348-1.323-.766-1.949-1.114-.627-.348-1.253-.766-1.95-1.114-.696-.418-.696-.696 0-1.114a199.803 199.803 0 013.899-2.297c.626-.348 1.253-.278 1.879.07z"
        fill="url(#paint16_linear_4171_3723)"
      />
      <path
        d="M352.355 246.061c-.07 0-.07 0 0 0l-2.089-1.253c-.557-.348-1.183-.696-1.74-1.044-.627-.348-.627-.696-.07-1.114 1.253-.766 2.576-1.531 3.899-2.297.626-.348 1.253-.348 1.949 0 .626.348 1.322.766 1.949 1.114.418.209.766.487 1.183.696.279.139.488.278.766.418.627.348.627.696 0 1.044l-3.968 2.297c-.696.557-1.253.487-1.879.139z"
        fill="url(#paint17_linear_4171_3723)"
      />
      <path
        d="M333.141 243.836l3.968-2.298a1.58 1.58 0 011.74 0c.627.348 1.323.766 1.949 1.114l2.089 1.253c.557.348.557.696 0 1.044-.696.418-1.323.766-2.019 1.184-.626.348-1.323.766-1.949 1.114-.627.348-1.253.348-1.88 0-.626-.348-1.253-.696-1.949-1.114-.696-.418-1.392-.835-2.088-1.184-.488-.348-.418-.765.139-1.113z"
        fill="url(#paint18_linear_4171_3723)"
      />
      <path
        d="M339.963 247.659c1.88-1.113 3.759-2.227 5.639-3.272.765-.417 1.322-.417 2.088 0 .696.349 1.323.766 2.019 1.114.627.348 1.183.696 1.81 1.045.766.417.696.696-.07 1.183-.905.557-1.879 1.114-2.784 1.671-.905.557-1.81 1.044-2.785 1.601-.835.487-1.323.487-2.158 0-.557-.348-1.114-.627-1.671-.975-.696-.417-1.392-.835-2.088-1.183-.766-.418-.766-.766 0-1.184z"
        fill="url(#paint19_linear_4171_3723)"
      />
      <path
        d="M353.329 255.315c1.184-.696 2.298-1.322 3.481-2.019 1.184-.696 2.297-1.392 3.481-2.018.835-.488 1.322-.488 2.088 0 .627.348 1.184.696 1.741 1.044.626.348 1.322.766 1.949 1.114.835.487.835.765 0 1.183-2.298 1.392-4.664 2.715-6.962 4.038-.765.487-1.322.487-2.158 0l-1.879-1.045c-.627-.348-1.253-.696-1.88-1.113-.626-.418-.626-.697.139-1.184z"
        fill="url(#paint20_linear_4171_3723)"
      />
      <path
        d="M412.64 203.246c.696.418.696.696 0 1.114-1.253.766-2.506 1.462-3.829 2.227-.696.418-1.253.418-1.949 0-.696-.417-1.392-.765-2.088-1.183-.557-.348-1.114-.696-1.671-.975-.766-.487-.766-.765.07-1.253.626-.348 1.183-.696 1.81-1.044.626-.348 1.253-.766 1.879-1.114.766-.417 1.253-.417 1.949 0 .836.488 1.601.905 2.437 1.393.418.278.905.557 1.392.835z"
        fill="url(#paint21_linear_4171_3723)"
      />
      <path
        d="M368.226 231.229c1.323-.765 2.645-1.601 4.038-2.366a1.58 1.58 0 011.74 0c.626.348 1.323.765 1.949 1.113.696.418 1.392.836 2.089 1.184.557.348.557.626 0 .974-1.323.766-2.715 1.602-4.108 2.367-.557.348-1.183.279-1.74-.069-.278-.139-.557-.348-.835-.488-.348-.208-.766-.417-1.114-.626-.418-.209-.836-.487-1.253-.696-.279-.139-.488-.279-.766-.418-.557-.348-.487-.696 0-.975z"
        fill="url(#paint22_linear_4171_3723)"
      />
      <path
        d="M378.321 233.111l3.968-2.297a1.58 1.58 0 011.74 0c.279.139.557.348.836.487.417.209.765.487 1.183.696.418.209.766.488 1.183.696.279.14.557.348.836.488.557.348.557.696.069.974-1.322.836-2.715 1.601-4.107 2.367-.557.279-1.183.279-1.671 0-.765-.418-1.461-.835-2.227-1.253-.627-.348-1.253-.696-1.88-1.114-.557-.348-.557-.696.07-1.044z"
        fill="url(#paint23_linear_4171_3723)"
      />
      <path
        d="M367.462 232.764c.696.349 1.323.766 1.949 1.114.627.348 1.253.766 1.88 1.114.766.418.766.696 0 1.114-1.253.766-2.576 1.462-3.829 2.228-.626.348-1.253.417-1.949 0l-1.88-1.045c-.696-.417-1.392-.765-2.019-1.183-.626-.348-.626-.766 0-1.114.627-.348 1.323-.766 1.95-1.114.626-.348 1.253-.765 1.879-1.114.836-.417 1.323-.417 2.019 0z"
        fill="url(#paint24_linear_4171_3723)"
      />
      <path
        d="M408.116 208.051c1.323-.766 2.576-1.532 3.898-2.298.627-.348 1.254-.348 1.88 0 .905.488 1.81 1.044 2.715 1.532.418.278.835.487 1.253.766.627.348.557.696-.07 1.044-.626.348-1.322.765-1.949 1.114-.626.348-1.322.765-1.949 1.113-.626.348-1.183.348-1.81 0-.348-.208-.696-.417-.975-.557-.348-.208-.696-.417-.974-.556-.696-.418-1.323-.766-2.019-1.184-.626-.278-.557-.696 0-.974z"
        fill="url(#paint25_linear_4171_3723)"
      />
      <path
        d="M401.501 211.879c1.323-.766 2.576-1.532 3.899-2.298.626-.348 1.253-.348 1.879 0 .279.14.557.279.835.488.418.208.766.417 1.184.696.418.209.766.487 1.183.696.279.139.557.278.766.418.627.348.557.696 0 1.044l-3.968 2.297c-.626.348-1.253.348-1.81 0-.418-.278-.905-.487-1.322-.766a51.421 51.421 0 01-2.646-1.531c-.626-.279-.626-.696 0-1.044z"
        fill="url(#paint26_linear_4171_3723)"
      />
      <path
        d="M411.458 213.83c.626-.348 1.253-.696 1.879-1.114.697-.418 1.323-.766 2.019-1.183.627-.349 1.253-.349 1.88 0 .835.487 1.601.905 2.436 1.392l1.462.835c.627.348.696.696.07 1.044l-3.968 2.298c-.627.348-1.253.348-1.81 0l-3.968-2.298c-.627-.278-.557-.626 0-.974z"
        fill="url(#paint27_linear_4171_3723)"
      />
      <path
        d="M394.818 215.777c1.322-.765 2.645-1.601 4.037-2.367.627-.348 1.253-.278 1.88.07.209.139.417.279.626.348.418.279.905.487 1.323.766.418.278.905.487 1.323.766.209.139.417.278.696.417.557.348.626.697.069.975-1.322.835-2.715 1.601-4.107 2.367-.557.278-1.114.348-1.671 0-.765-.418-1.531-.836-2.297-1.323-.626-.348-1.183-.696-1.81-1.044-.626-.278-.626-.627-.069-.975z"
        fill="url(#paint28_linear_4171_3723)"
      />
      <path
        d="M404.843 217.726l3.968-2.297a1.58 1.58 0 011.74 0c.209.139.418.278.696.418.418.278.905.487 1.323.765.418.209.835.488 1.184.697.278.139.487.278.765.417h.07c.626.348.557.696-.07 1.044-1.253.766-2.575 1.462-3.828 2.228-.627.348-1.254.418-1.88 0-1.114-.626-2.228-1.253-3.342-1.949-.208-.139-.417-.279-.626-.348-.627-.279-.627-.627 0-.975z"
        fill="url(#paint29_linear_4171_3723)"
      />
      <path
        d="M426.076 219.814c-1.323.766-2.646 1.601-4.038 2.367a1.58 1.58 0 01-1.74 0c-.279-.139-.557-.348-.835-.487-.418-.209-.766-.488-1.184-.697-.278-.139-.487-.278-.766-.417-.417-.209-.835-.488-1.253-.696-.626-.348-.626-.697-.069-1.045 1.322-.765 2.645-1.601 4.037-2.366.557-.279 1.184-.279 1.671 0 .766.417 1.462.835 2.228 1.253.626.348 1.253.765 1.949 1.113.557.279.557.697 0 .975z"
        fill="url(#paint30_linear_4171_3723)"
      />
      <path
        d="M388.204 219.603c1.323-.766 2.576-1.531 3.898-2.297.627-.348 1.254-.348 1.95 0 .348.209.765.418 1.114.696.905.557 1.879 1.044 2.784 1.601.627.348.627.766 0 1.114-.626.348-1.253.696-1.879 1.114-.627.348-1.254.766-1.95 1.114-.765.417-1.183.417-1.949 0-.418-.209-.835-.488-1.323-.766-.348-.209-.626-.348-.974-.557-.348-.209-.627-.418-.975-.557-.209-.139-.417-.209-.626-.348-.627-.418-.696-.766-.07-1.114z"
        fill="url(#paint31_linear_4171_3723)"
      />
      <path
        d="M398.16 221.554c.696-.418 1.323-.766 2.019-1.184.696-.417 1.322-.765 2.018-1.183a1.582 1.582 0 011.741 0c.766.418 1.462.835 2.228 1.253.278.139.556.348.904.487.279.139.557.348.905.487.627.349.627.697 0 1.045l-3.968 2.297c-.626.348-1.253.348-1.879 0l-1.462-.835-2.506-1.462c-.557-.209-.557-.557 0-.905z"
        fill="url(#paint32_linear_4171_3723)"
      />
      <path
        d="M419.461 223.712c-.696.418-1.322.766-2.019 1.183-.696.418-1.322.766-2.018 1.184-.557.278-1.184.348-1.671.069-.696-.417-1.392-.765-2.088-1.183-.697-.418-1.323-.766-2.019-1.183-.627-.349-.627-.766 0-1.114 1.322-.766 2.575-1.532 3.898-2.298a1.58 1.58 0 011.74 0c.766.418 1.462.836 2.228 1.253.627.349 1.323.766 1.949 1.114.488.279.488.627 0 .975z"
        fill="url(#paint33_linear_4171_3723)"
      />
      <path
        d="M381.453 223.502c1.322-.835 2.715-1.601 4.107-2.367.557-.348 1.183-.278 1.74.07.279.139.557.348.836.487.348.209.766.418 1.114.627.417.278.835.487 1.253.765.278.14.487.279.765.418.557.348.627.627 0 .975-1.322.765-2.715 1.531-4.037 2.366a1.578 1.578 0 01-1.741 0l-1.879-1.044c-.766-.417-1.462-.835-2.228-1.253-.417-.348-.418-.696.07-1.044z"
        fill="url(#paint34_linear_4171_3723)"
      />
      <path
        d="M429.348 225.659c-.627.348-1.253.696-1.88 1.114-.626.348-1.322.766-1.949 1.114-.766.418-1.253.418-2.019 0-.626-.348-1.322-.766-1.949-1.114l-1.879-1.044c-.697-.418-.766-.696-.07-1.114a190.102 190.102 0 013.898-2.297c.627-.348 1.253-.348 1.81 0 .418.278.905.487 1.323.765.905.488 1.74 1.045 2.645 1.532.696.348.696.696.07 1.044z"
        fill="url(#paint35_linear_4171_3723)"
      />
      <path
        d="M391.616 225.383c1.253-.766 2.576-1.532 3.898-2.298.627-.348 1.253-.348 1.88 0 1.114.627 2.227 1.323 3.341 1.949.209.14.348.209.557.349.627.348.627.696 0 1.044l-3.968 2.297c-.626.348-1.253.348-1.81 0-.209-.139-.417-.278-.626-.348-.418-.279-.836-.487-1.323-.766a10.33 10.33 0 01-1.183-.696 4.614 4.614 0 01-.766-.487c-.696-.348-.696-.627 0-1.044z"
        fill="url(#paint36_linear_4171_3723)"
      />
      <path
        d="M429.556 227.54c-.557-.348-.557-.696 0-1.044.627-.348 1.323-.766 1.95-1.114.696-.418 1.392-.835 2.088-1.183.557-.279 1.114-.349 1.671 0 .626.348 1.322.765 1.949 1.113.696.418 1.462.836 2.158 1.253.557.349.487.697 0 .975-1.323.766-2.645 1.601-4.038 2.367a1.58 1.58 0 01-1.74 0c-.696-.418-1.392-.766-2.019-1.184a19.246 19.246 0 00-2.019-1.183z"
        fill="url(#paint37_linear_4171_3723)"
      />
      <path
        d="M412.779 227.542l-3.968 2.297c-.627.348-1.254.348-1.88 0a4.698 4.698 0 01-.766-.487c-.418-.209-.766-.487-1.183-.696-.348-.209-.766-.418-1.114-.627-.279-.139-.487-.278-.766-.417-.696-.418-.696-.696 0-1.114 1.253-.766 2.576-1.462 3.829-2.228.626-.348 1.253-.418 1.88 0 .417.209.765.487 1.183.696.418.209.766.488 1.183.696.557.279 1.045.627 1.602.905.556.279.556.627 0 .975z"
        fill="url(#paint38_linear_4171_3723)"
      />
      <path
        d="M422.733 229.491c-.626.348-1.322.765-1.949 1.113-.696.418-1.322.766-2.019 1.184-.626.348-1.183.348-1.81 0-.556-.279-1.044-.627-1.601-.905-.348-.209-.626-.348-.974-.557-.488-.279-.975-.557-1.393-.835-.626-.349-.626-.697 0-1.114l3.968-2.298c.557-.348 1.184-.348 1.81 0 .697.418 1.393.836 2.089 1.184.626.348 1.323.766 1.949 1.114.557.417.487.765-.07 1.114z"
        fill="url(#paint39_linear_4171_3723)"
      />
      <path
        d="M384.934 229.279l3.968-2.297c.627-.348 1.184-.348 1.81 0 .209.139.418.278.627.348.417.278.905.487 1.322.766.418.278.905.487 1.323.765.209.14.418.279.696.418.557.348.557.696 0 1.044l-3.968 2.297c-.626.349-1.253.349-1.879 0-.557-.278-1.114-.626-1.671-.974-.766-.418-1.532-.905-2.367-1.392-.487-.279-.487-.627.139-.975z"
        fill="url(#paint40_linear_4171_3723)"
      />
      <path
        d="M423.014 231.44c-.626-.348-.626-.766.07-1.114.626-.348 1.323-.766 1.949-1.114.627-.348 1.323-.765 1.949-1.113.557-.348 1.184-.348 1.741-.07.835.487 1.601.905 2.436 1.392.557.348 1.114.627 1.601.975.627.348.557.696 0 1.044-1.322.766-2.575 1.532-3.898 2.297a1.95 1.95 0 01-1.949 0c-.557-.348-1.184-.626-1.741-.974-.696-.488-1.462-.905-2.158-1.323z"
        fill="url(#paint41_linear_4171_3723)"
      />
      <path
        d="M406.165 231.367l-3.968 2.297c-.627.348-1.253.348-1.81 0-.557-.348-1.183-.696-1.74-1.044a37.731 37.731 0 01-2.228-1.323c-.557-.348-.627-.696-.07-1.044 1.323-.766 2.646-1.601 4.038-2.367a1.58 1.58 0 011.74 0c.279.139.557.279.766.487.418.209.835.488 1.253.697.418.278.905.487 1.323.765.209.139.417.279.626.348.557.488.627.836.07 1.184z"
        fill="url(#paint42_linear_4171_3723)"
      />
      <path
        d="M415.983 233.39c-.627.348-1.253.696-1.88 1.113-.696.418-1.322.766-2.018 1.184a1.582 1.582 0 01-1.741 0c-.696-.418-1.392-.766-2.088-1.184-.627-.348-1.253-.765-1.88-1.113-.626-.348-.626-.697 0-1.045l3.968-2.297c.627-.348 1.253-.348 1.81 0l.418.209c.348.209.626.348.974.557l1.045.626c.487.279.974.557 1.531.905.627.348.627.627-.139 1.045z"
        fill="url(#paint43_linear_4171_3723)"
      />
      <path
        d="M416.331 234.222c.696-.417 1.323-.765 2.019-1.183.627-.348 1.323-.766 1.949-1.114.627-.348 1.253-.348 1.88 0 .348.209.626.348.974.557.975.557 2.019 1.114 2.994 1.74.626.348.626.697.069 1.045l-3.968 2.297c-.556.348-1.253.348-1.879 0l-3.968-2.297c-.627-.348-.627-.697-.07-1.045z"
        fill="url(#paint44_linear_4171_3723)"
      />
      <path
        d="M399.483 235.269l-3.968 2.298c-.627.348-1.253.348-1.81 0-.557-.349-1.114-.627-1.671-.975-.766-.418-1.531-.905-2.367-1.323-.626-.348-.626-.696 0-1.044.627-.418 1.323-.766 1.949-1.114.627-.348 1.323-.766 1.95-1.114.626-.348 1.253-.348 1.949 0 .696.418 1.392.766 2.019 1.184.626.348 1.322.766 1.949 1.114.557.278.626.626 0 .974z"
        fill="url(#paint45_linear_4171_3723)"
      />
      <path
        d="M409.437 237.215l-3.968 2.297c-.626.348-1.253.348-1.81 0-.696-.417-1.462-.835-2.158-1.253-.626-.348-1.253-.696-1.81-1.044-.557-.348-.557-.696 0-1.044 1.323-.766 2.645-1.601 4.038-2.367a1.58 1.58 0 011.74 0c.279.139.557.348.905.487.418.209.766.418 1.184.696.417.209.835.488 1.183.697.278.139.487.278.766.417.557.418.557.766-.07 1.114z"
        fill="url(#paint46_linear_4171_3723)"
      />
      <path
        d="M379.504 235.828c.139.07.348.209.487.278l1.462.836c.626.348.557.696 0 1.044l-3.968 2.297c-.627.348-1.253.348-1.81 0-.348-.209-.627-.348-.975-.557-.348-.208-.626-.348-.974-.556-.418-.209-.766-.488-1.184-.697-.278-.139-.557-.278-.765-.487-.627-.348-.627-.696 0-1.114 1.322-.766 2.575-1.531 3.898-2.297.696-.418 1.183-.418 1.88 0 .417.209.835.487 1.253.696.139.279.417.418.696.557z"
        fill="url(#paint47_linear_4171_3723)"
      />
      <path
        d="M409.648 239.097c-.557-.348-.557-.696 0-1.045.696-.417 1.323-.765 2.019-1.183.627-.348 1.323-.766 1.949-1.114.627-.348 1.184-.348 1.81 0l1.88 1.044c.696.418 1.392.836 2.158 1.253.626.349.626.697 0 1.045l-3.968 2.297a1.582 1.582 0 01-1.741 0c-.626-.348-1.253-.696-1.879-1.114-.766-.348-1.462-.766-2.228-1.183z"
        fill="url(#paint48_linear_4171_3723)"
      />
      <path
        d="M392.801 239.163c-1.322.766-2.575 1.531-3.898 2.297-.627.348-1.253.348-1.88 0-.626-.348-1.322-.766-1.949-1.114l-2.088-1.253c-.488-.278-.557-.696 0-.974 1.322-.836 2.715-1.601 4.107-2.367a1.773 1.773 0 011.671 0c.209.139.417.278.696.418.418.278.905.487 1.392.765.418.209.766.488 1.184.696.278.14.487.279.765.418.627.348.627.696 0 1.114z"
        fill="url(#paint49_linear_4171_3723)"
      />
      <path
        d="M402.824 241.044c-.696.418-1.322.766-2.018 1.184-.697.418-1.323.766-2.019 1.183-.557.279-1.114.348-1.671 0-.835-.487-1.601-.905-2.436-1.392-.557-.348-1.114-.626-1.741-.975-.557-.348-.557-.696 0-.974 1.323-.836 2.715-1.601 4.107-2.367.557-.278 1.184-.278 1.671 0 .696.348 1.323.766 2.019 1.114.696.417 1.392.835 2.088 1.183.557.348.557.696 0 1.044z"
        fill="url(#paint50_linear_4171_3723)"
      />
      <path
        d="M367.391 243.275c-.765-.487-1.601-.905-2.367-1.392-.626-.349-.556-.766.07-1.114.627-.348 1.253-.696 1.88-1.114.626-.348 1.253-.766 1.879-1.114.766-.418 1.253-.487 2.019 0 .418.209.766.487 1.183.696l1.045.627c.278.209.626.348.905.557.208.139.487.278.696.417.626.348.626.696 0 1.114-1.323.766-2.576 1.532-3.899 2.297a1.7 1.7 0 01-1.81 0c-.556-.348-1.044-.696-1.601-.974z"
        fill="url(#paint51_linear_4171_3723)"
      />
      <path
        d="M403.033 242.995c-.557-.348-.557-.697 0-1.045.696-.417 1.323-.765 2.019-1.183.626-.348 1.253-.766 1.879-1.114.766-.418 1.253-.418 1.95 0 .556.348 1.183.627 1.74.975.696.417 1.462.835 2.158 1.253.557.348.626.696 0 1.044-1.323.766-2.576 1.531-3.898 2.297-.627.348-1.254.418-1.88 0a16.303 16.303 0 00-.975-.557 114.788 114.788 0 00-2.993-1.67z"
        fill="url(#paint52_linear_4171_3723)"
      />
      <path
        d="M386.187 242.995c-1.323.766-2.576 1.532-3.899 2.297a1.95 1.95 0 01-1.949 0c-.627-.348-1.183-.696-1.74-1.044-.696-.418-1.462-.835-2.158-1.253-.627-.348-.627-.696 0-1.044.626-.418 1.322-.766 1.949-1.114.696-.418 1.322-.766 2.019-1.183.626-.348 1.253-.348 1.879 0 .627.348 1.323.765 1.949 1.113.627.349 1.323.766 1.95 1.114.626.348.626.766 0 1.114z"
        fill="url(#paint53_linear_4171_3723)"
      />
      <path
        d="M396.211 244.878l-3.968 2.298c-.626.348-1.253.348-1.81 0a5.167 5.167 0 01-.835-.488 10.28 10.28 0 01-1.184-.696c-.417-.209-.765-.487-1.183-.696-.279-.139-.557-.348-.835-.487-.557-.348-.627-.696-.07-1.044 1.323-.766 2.645-1.601 4.038-2.367a1.58 1.58 0 011.74 0c.487.278.974.557 1.392.835.905.487 1.741 1.044 2.646 1.532.626.487.626.835.069 1.113z"
        fill="url(#paint54_linear_4171_3723)"
      />
      <path
        d="M360.081 246.756c-.557-.348-1.114-.696-1.74-.974-.557-.349-.627-.697 0-1.045 1.322-.765 2.715-1.531 4.037-2.367a1.582 1.582 0 011.741 0c.278.14.557.279.835.488.418.209.835.487 1.253.696.418.278.905.487 1.323.766.209.139.417.278.696.417.626.348.626.696 0 1.045l-3.968 2.297c-.627.348-1.253.348-1.81 0-.905-.488-1.601-.905-2.367-1.323z"
        fill="url(#paint55_linear_4171_3723)"
      />
      <path
        d="M398.23 247.869c-.348-.209-.627-.348-.975-.557-.278-.139-.557-.279-.766-.487-.626-.349-.626-.697 0-1.114l3.968-2.298c.627-.348 1.184-.348 1.81 0 .279.14.557.348.905.488l1.045.626c.348.209.765.418 1.113.627.279.139.488.278.766.417.766.488.766.697 0 1.184-1.253.766-2.506 1.462-3.759 2.158-.766.418-1.253.418-2.019 0a10.567 10.567 0 01-1.183-.696c-.279 0-.627-.139-.905-.348z"
        fill="url(#paint56_linear_4171_3723)"
      />
      <path
        d="M379.574 246.825c-1.323.766-2.576 1.532-3.898 2.297-.627.349-1.253.349-1.88 0-.627-.348-1.253-.696-1.88-1.113-.696-.418-1.392-.766-2.018-1.184-.627-.348-.627-.766 0-1.114.626-.348 1.322-.765 1.949-1.113.626-.349 1.322-.766 1.949-1.114.627-.348 1.253-.348 1.88 0 .696.348 1.322.765 2.018 1.114.697.417 1.323.765 2.019 1.183.488.348.418.696-.139 1.044z"
        fill="url(#paint57_linear_4171_3723)"
      />
      <path
        d="M389.527 248.771c-.626.348-1.253.696-1.879 1.114-.627.348-1.253.766-1.949 1.114-.766.417-1.254.417-2.019 0-.627-.348-1.253-.696-1.88-1.114-.626-.348-1.253-.766-1.879-1.114-.697-.418-.697-.766 0-1.183a191.975 191.975 0 013.898-2.298c.626-.348 1.253-.348 1.88 0a21.86 21.86 0 001.74.975c.766.418 1.531.835 2.228 1.323.487.487.487.835-.14 1.183z"
        fill="url(#paint58_linear_4171_3723)"
      />
      <path
        d="M389.807 250.724c-.626-.348-.626-.766.07-1.114.626-.348 1.323-.766 1.949-1.114.627-.348 1.323-.766 1.949-1.114.627-.348 1.184-.348 1.81 0l1.462.836c.835.487 1.601.974 2.437 1.392.626.348.696.766.069 1.114-1.322.765-2.575 1.531-3.898 2.297-.627.348-1.253.348-1.949 0-.418-.279-.905-.487-1.323-.766a31.217 31.217 0 00-2.576-1.531z"
        fill="url(#paint59_linear_4171_3723)"
      />
      <path
        d="M363.214 250.723c-.626-.348-.626-.766 0-1.114 1.323-.766 2.576-1.531 3.898-2.297.627-.348 1.253-.348 1.81 0 .348.209.697.418 1.045.557.348.209.696.417 1.044.557.418.278.905.487 1.323.765.208.14.417.279.696.418.626.348.626.696 0 1.044-1.323.766-2.576 1.532-3.899 2.298-.626.348-1.253.417-1.949 0-.487-.279-1.044-.557-1.531-.905a20.2 20.2 0 01-2.437-1.323z"
        fill="url(#paint60_linear_4171_3723)"
      />
      <path
        d="M382.915 252.606c-.626.348-1.322.766-1.949 1.114-.696.417-1.323.765-2.019 1.183-.626.348-1.253.348-1.879 0-.279-.139-.627-.348-.905-.487-.279-.139-.627-.348-.905-.487-.279-.14-.488-.279-.766-.418-.418-.279-.835-.487-1.253-.766-.696-.418-.696-.696 0-1.114 1.253-.765 2.576-1.462 3.829-2.227.626-.348 1.253-.348 1.949 0 .418.208.835.487 1.253.696.418.209.835.487 1.253.696.348.209.696.418 1.044.557.139.069.348.209.487.278.488.279.418.627-.139.975z"
        fill="url(#paint61_linear_4171_3723)"
      />
      <path
        d="M346.645 251.488c1.392-.835 2.854-1.67 4.316-2.506 1.462-.835 2.924-1.74 4.455-2.576.835-.487 1.323-.487 2.158 0 .627.349 1.323.766 1.949 1.114.557.348 1.184.696 1.741 1.045.696.417.765.696 0 1.113-2.924 1.741-5.918 3.411-8.841 5.152-.766.417-1.323.417-2.089 0-.626-.348-1.183-.696-1.74-.975-.627-.348-1.323-.766-1.949-1.114-.766-.487-.766-.765 0-1.253z"
        fill="url(#paint62_linear_4171_3723)"
      />
      <path
        d="M383.192 254.552c-.626-.348-.557-.696 0-1.044.627-.349 1.323-.766 1.949-1.114.697-.418 1.323-.766 2.019-1.184a1.582 1.582 0 011.741 0c.696.418 1.392.766 2.018 1.184.697.417 1.323.765 2.019 1.183.557.348.557.696 0 1.044l-3.968 2.298c-.626.348-1.183.348-1.81 0-.557-.348-1.183-.696-1.74-1.045a37.17 37.17 0 00-2.228-1.322z"
        fill="url(#paint63_linear_4171_3723)"
      />
      <path
        d="M359.942 259.215c1.253-.765 2.576-1.462 3.829-2.227.626-.348 1.253-.348 1.879 0 .696.417 1.393.765 2.089 1.183l1.879 1.044c.627.348.557.696-.069 1.114-.627.348-1.323.766-1.949 1.114-.418.278-.905.487-1.323.766-.139.069-.348.209-.487.278-.836.487-1.323.487-2.089 0l-1.879-1.044c-.627-.348-1.253-.696-1.88-1.114-.696-.348-.696-.696 0-1.114z"
        fill="url(#paint64_linear_4171_3723)"
      />
      <path
        d="M376.232 256.502c-1.323.766-2.576 1.532-3.899 2.228-.626.348-1.253.348-1.879 0-.279-.139-.557-.348-.836-.487-.348-.209-.765-.418-1.114-.627-.556-.348-1.113-.626-1.67-.974-.07 0-.07-.07-.14-.07-.765-.487-.835-.766 0-1.253 1.184-.696 2.437-1.462 3.69-2.158.766-.418 1.323-.418 2.019 0 .557.278 1.044.626 1.601.905l1.044.626c.279.14.557.349.836.488.139.069.208.139.348.209.626.348.626.765 0 1.113z"
        fill="url(#paint65_linear_4171_3723)"
      />
      <path
        d="M376.511 258.383c-.556-.348-.556-.696 0-1.044 1.323-.766 2.715-1.532 4.038-2.367a1.58 1.58 0 011.74 0c.279.139.557.278.836.487.417.209.835.488 1.183.696.418.209.836.488 1.253.697.279.139.488.278.766.417.627.348.627.696 0 1.044l-3.968 2.298c-.627.348-1.253.348-1.88 0l-2.506-1.462c-.487-.139-.974-.418-1.462-.766z"
        fill="url(#paint66_linear_4171_3723)"
      />
      <path
        d="M366.626 263.117c2.367-1.392 4.803-2.784 7.17-4.177.696-.417 1.183-.417 1.949 0 .627.348 1.184.696 1.81 1.044.696.418 1.323.766 2.019 1.184.766.418.766.696 0 1.183-1.184.696-2.297 1.323-3.481 2.019-1.183.696-2.297 1.392-3.481 2.019-.835.487-1.392.487-2.227 0-.627-.348-1.323-.766-1.949-1.114-.627-.348-1.184-.696-1.81-1.044-.697-.348-.697-.696 0-1.114z"
        fill="url(#paint67_linear_4171_3723)"
      />
      <path
        d="M405.959 207.144c.696.418.765.697 0 1.114a103.07 103.07 0 00-2.854 1.671c-.975.557-1.88 1.114-2.855 1.671-.765.417-1.253.417-2.018 0-.697-.418-1.393-.766-2.019-1.184-.557-.348-1.184-.696-1.741-1.044-.696-.418-.765-.696 0-1.114 1.88-1.114 3.76-2.227 5.709-3.341.765-.418 1.253-.418 2.019 0 .626.348 1.253.696 1.879 1.114.627.348 1.253.765 1.88 1.113z"
        fill="url(#paint68_linear_4171_3723)"
      />
      <path
        d="M353.12 233.384c-.696-.417-.696-.765 0-1.114 1.879-1.113 3.829-2.227 5.708-3.341.627-.348 1.253-.348 1.949 0 .209.139.488.278.696.418.209.139.488.278.697.417.348.209.696.348.974.557l1.462.836c.696.417.766.696 0 1.113a103.07 103.07 0 01-2.854 1.671c-.975.557-1.88 1.114-2.854 1.671-.766.418-1.253.418-2.019 0-.696-.348-1.323-.766-2.019-1.183a37.733 37.733 0 00-1.74-1.045z"
        fill="url(#paint69_linear_4171_3723)"
      />
      <path
        d="M436.239 223.711c-.557-.348-.626-.696 0-1.044 1.323-.766 2.715-1.532 4.038-2.367.626-.348 1.253-.348 1.81 0 .626.348 1.322.766 1.949 1.114.418.209.835.487 1.253.696.278.139.487.279.766.418.626.348.626.696 0 1.044l-3.968 2.297a1.7 1.7 0 01-1.81 0c-.209-.139-.348-.209-.557-.348-1.184-.487-2.367-1.183-3.481-1.81z"
        fill="url(#paint70_linear_4171_3723)"
      />
      <path
        d="M442.853 219.815c-.557-.348-.557-.696 0-.974 1.393-.766 2.715-1.601 4.107-2.367.557-.348 1.114-.279 1.671 0 .279.139.557.348.905.487.418.209.766.418 1.184.696.417.209.765.418 1.183.697.279.139.557.278.835.487h.07c.627.348.627.696 0 1.044-1.323.766-2.576 1.532-3.898 2.297-.627.348-1.253.348-1.88 0-.626-.348-1.253-.696-1.88-1.114-.904-.417-1.601-.835-2.297-1.253z"
        fill="url(#paint71_linear_4171_3723)"
      />
      <path
        d="M436.031 221.766l-3.968 2.297c-.626.348-1.253.348-1.81 0-.278-.139-.487-.278-.765-.418-.418-.278-.836-.487-1.253-.765-.348-.209-.627-.348-.975-.557-.348-.209-.627-.348-.975-.557-.626-.348-.696-.766 0-1.114 1.323-.766 2.576-1.531 3.899-2.297.626-.348 1.253-.348 1.879 0 .627.348 1.323.766 1.95 1.114.626.348 1.322.765 1.949 1.113.626.488.626.836.069 1.184z"
        fill="url(#paint72_linear_4171_3723)"
      />
      <path
        d="M429.557 212.155c-.556-.348-.626-.696 0-1.044l3.968-2.297c.627-.348 1.184-.348 1.81 0 .209.139.418.278.627.348.418.278.905.487 1.323.766.557.348 1.183.696 1.74 1.044.07 0 .07.069.139.069.766.488.766.766.07 1.184-1.253.766-2.576 1.462-3.829 2.228a1.95 1.95 0 01-1.949 0l-1.88-1.045c-.696-.487-1.392-.835-2.019-1.253z"
        fill="url(#paint73_linear_4171_3723)"
      />
      <path
        d="M432.62 216.056c-1.253.766-2.576 1.462-3.829 2.228-.626.348-1.253.418-1.949 0-.557-.279-1.044-.627-1.601-.905-.348-.209-.626-.348-.975-.557a24.733 24.733 0 01-1.392-.835c-.626-.348-.626-.766 0-1.114 1.323-.766 2.576-1.532 3.899-2.297a1.945 1.945 0 011.949 0c.626.348 1.253.696 1.879 1.113.418.209.836.488 1.184.696.278.14.487.279.766.418.696.487.765.836.069 1.253z"
        fill="url(#paint74_linear_4171_3723)"
      />
      <path
        d="M442.644 217.938c-.697.418-1.323.766-2.019 1.184-.627.348-1.253.766-1.88 1.114-.766.417-1.253.417-1.949 0-.627-.348-1.183-.696-1.81-1.044-.696-.418-1.392-.766-2.088-1.184-.627-.348-.627-.766 0-1.114 1.322-.765 2.575-1.531 3.898-2.297.627-.348 1.253-.348 1.88 0 .626.348 1.253.696 1.949 1.114.696.418 1.462.835 2.158 1.253.487.278.418.626-.139.974z"
        fill="url(#paint75_linear_4171_3723)"
      />
      <path
        d="M375.049 227.262c.626-.348 1.253-.766 1.88-1.114.626-.348 1.322-.765 1.949-1.114.626-.348 1.253-.348 1.949 0 1.044.627 2.088 1.184 3.133 1.81.278.14.556.279.765.488.627.348.627.696 0 1.044l-3.968 2.297c-.626.348-1.183.348-1.81 0-.765-.417-1.531-.835-2.227-1.322-.557-.348-1.114-.627-1.671-.975-.766-.418-.766-.696 0-1.114z"
        fill="url(#paint76_linear_4171_3723)"
      />
      <path
        d="M414.799 204.148c1.323-.766 2.576-1.531 3.899-2.297a1.95 1.95 0 011.949 0c.835.487 1.601.905 2.436 1.392l1.462.836c.696.417.696.696 0 1.113-.626.348-1.253.697-1.879 1.114-.627.348-1.323.766-1.95 1.114-.626.348-1.253.418-1.879 0-.348-.209-.627-.348-.975-.557l-2.924-1.671c-.835-.278-.765-.696-.139-1.044z"
        fill="url(#paint77_linear_4171_3723)"
      />
      <path
        d="M419.323 199.485c.557.348.557.696 0 1.044-.626.348-1.322.766-1.949 1.114-.696.418-1.323.766-2.019 1.183-.626.348-1.183.348-1.81 0-.417-.209-.835-.487-1.253-.696-.278-.139-.626-.348-.905-.487-.626-.348-1.253-.696-1.81-1.044-.626-.348-.626-.697 0-1.045l3.968-2.297a1.582 1.582 0 011.741 0c.765.418 1.531.905 2.297 1.323.626.209 1.183.557 1.74.905z"
        fill="url(#paint78_linear_4171_3723)"
      />
      <path
        d="M418.138 209.998l3.968-2.297a1.577 1.577 0 011.74 0c.279.139.557.278.766.417.418.209.835.487 1.253.696.418.209.836.488 1.253.696.279.14.557.279.766.488.557.348.557.696 0 1.044l-3.968 2.297c-.627.348-1.253.348-1.88 0l-1.879-1.044a59.897 59.897 0 00-2.158-1.253c-.557-.348-.488-.696.139-1.044z"
        fill="url(#paint79_linear_4171_3723)"
      />
      <path
        d="M432.619 192.804c-.627.348-1.323.765-1.949 1.114-.627.348-1.253.765-1.95 1.113-.765.418-1.253.418-1.949 0-.557-.278-1.114-.626-1.671-.905-.278-.139-.556-.348-.905-.487-.348-.209-.626-.348-.974-.557a81.395 81.395 0 01-.418-.209c-.626-.348-.626-.765-.069-1.113l3.968-2.298a1.58 1.58 0 011.74 0c.905.557 1.88 1.044 2.785 1.601.417.209.835.488 1.253.697.696.348.696.696.139 1.044z"
        fill="url(#paint80_linear_4171_3723)"
      />
      <path
        d="M385.421 191.412v-.07V191.133v-.07V190.855c0-.07 0-.07.07-.14v-.069c0-.07 0-.07.069-.139 0-.07 0-.07.07-.14 0-.069 0-.069.07-.139 0-.07.069-.07.069-.139v-.139c0-.07.07-.07.07-.14v-.069-.139c0-.07.069-.07.069-.14 0 0 0-.069.07-.069 0 0 0-.07.07-.07.069-.07.139-.139.139-.278v-.07c0-.07.07-.07.07-.139l.069-.07v-.069c.07-.07.07-.14.139-.14l.07-.069.139-.14.07-.069.139-.139.07-.07.139-.139.07-.07c.069 0 .069-.069.139-.069.069 0 .069-.07.139-.07s.07-.07.139-.07l.07-.069c.069 0 .069-.07.139-.07l85.626-49.426s.069 0 .069-.07c.07 0 .07-.069.139-.069h.07c.07 0 .07 0 .139-.07.07 0 .07 0 .139-.069H475.084c.07 0 .07 0 .139.069.07 0 .14.07.209.07l2.228 1.322c-.07-.069-.139-.069-.209-.069-.069 0-.139 0-.139-.07h-.279-.278c-.07 0-.139 0-.209.07-.069 0-.139.069-.278.069-.07 0-.209.07-.279.14-.069.069-.209.069-.278.139l-85.626 49.426c-.069.07-.139.07-.209.139-.069.07-.139.139-.208.139l-.209.209-.209.209-.209.209-.209.209c-.069.069-.139.139-.139.209l-.07.069c0 .07-.069.07-.069.14-.07.069-.139.139-.139.278 0 0 0 .07-.07.07 0 0 0 .069-.07.069-.069.07-.069.139-.139.209v.07c-.069.069-.069.209-.139.278-.07.07-.07.209-.139.279-.07.069-.07.208-.14.278 0 .07-.069.209-.069.278 0 .07-.07.209-.07.279 0 .07-.069.209-.069.278l-11.417 82.841-2.228-1.322 11.556-82.98z"
        fill="url(#paint81_linear_4171_3723)"
      />
      <path
        d="M390.432 188.487c-1.322.766-2.506 2.576-2.715 4.247l-11.416 82.841 91.264-52.698 11.277-81.658c.279-2.088-1.044-3.132-2.715-2.158l-85.695 49.426z"
        fill="#F8F8F8"
      />
      <path
        d="M427.26 199c-2.158-2.367-4.595-3.203-7.519-2.228-1.392.487-2.436 1.462-2.993 2.993-.139.348-.07.766-.07 1.114h1.044c.209 0 .349-.139.557-.209.279 0 .627.07.905.07-.974.975-2.088 1.88-2.923 2.993-1.114 1.602-1.323 3.481-.627 5.361.418 1.183.766 1.322 1.601.417 2.715-2.784 5.917-4.664 9.677-5.499.487-.07 1.183.139 1.531.487 1.74 1.601 2.924 3.69 3.69 5.987.348.975.696 1.044 1.392.348 1.253-1.253 1.531-3.55.557-5.569l-.627-1.044c.488.139.905.209 1.393.348 1.253.696 2.506 1.322 3.759 2.088.765.418.974.07 1.114-.626.208-1.601-.279-2.994-1.254-4.247-.974-1.253-2.297-1.949-3.759-2.367.488-.278.905-.487 1.393-.765 1.253-.209 2.506-.488 3.759-.697.766-.139.626-.626.348-1.183-.905-1.532-2.228-2.437-3.829-2.924-3.341-.905-7.309 1.114-8.493 4.247-.348.348-.487.626-.626.905zm1.322 22.763c.139.488.627.836.905 1.254 0-.488.209-1.045.07-1.532-1.323-4.177-2.089-8.354-2.158-12.739 0-.836.139-1.671.069-2.437 0-.348-.278-.626-.487-.974-.209.278-.557.556-.557.905-.348 3.968.139 7.866 1.114 12.182.279.766.627 2.088 1.044 3.341z"
        fill="url(#paint82_linear_4171_3723)"
      />
      <path
        d="M427.26 199c.417.766.766 1.601 1.253 2.437 1.531-1.88 3.62-2.506 5.987-2.019.487-.278.905-.487 1.392-.766-.418-.696-.07-1.044.557-1.183.696-.139 1.462-.348 2.228-.557-.975-1.323-1.88-1.81-3.203-2.089-2.784-.487-4.873.766-6.543 2.924-.418.488-.697.905-1.323.279-.07.417-.209.696-.348.974z"
        fill="url(#paint83_linear_4171_3723)"
      />
      <path
        d="M434.709 204.637c.07-.835.557-.905 1.183-.626.836.348 1.602.766 2.437 1.183.209-1.67-.975-3.341-2.994-4.316-1.601-.766-4.733-.696-5.499.836l3.55 2.506c.418.209.905.278 1.323.417z"
        fill="url(#paint84_linear_4171_3723)"
      />
      <path
        d="M419.254 200.809c2.576-1.183 5.152-1.461 7.866.209-.208-.348-.348-.765-.556-1.114-1.602-2.297-5.152-3.063-7.31-1.531-.766.557-1.462 1.183-.835 2.367.209 0 .487 0 .835.069z"
        fill="url(#paint85_linear_4171_3723)"
      />
      <path
        d="M416.677 208.606c2.994-2.924 6.335-4.804 10.234-5.639-.766-1.81-3.551-2.506-5.987-1.671-3.272 1.183-5.082 4.177-4.247 7.31z"
        fill="url(#paint86_linear_4171_3723)"
      />
      <path
        d="M429.209 203.385c1.323 2.019 2.576 4.038 3.829 6.057.696-.697.766-2.159 0-3.62-.836-1.741-2.298-2.646-3.829-2.437z"
        fill="url(#paint87_linear_4171_3723)"
      />
      <path
        d="M341.075 253.498s2.994-7.449 15.803-3.133c0 0 4.107 2.019 2.784 7.101-1.392 5.081-9.259 7.17-9.259 7.17s-3.202 1.323-3.55 1.323c-.348 0-7.588-9.538-5.778-12.461z"
        fill="#F8F8F8"
      />
      <path
        d="M350.335 262.895c4.805 0 8.701-2.119 8.701-4.734 0-2.614-3.896-4.733-8.701-4.733-4.806 0-8.702 2.119-8.702 4.733 0 2.615 3.896 4.734 8.702 4.734z"
        fill="#A9653A"
      />
      <path
        d="M339.543 274.039l.139-19.91h.139v.348c0 3.341 4.665 5.987 10.582 5.987 5.917 0 10.72-2.715 10.72-5.987v19.562s-2.506 5.012-10.72 5.012c-8.284-.07-10.86-5.012-10.86-5.012z"
        fill="#F8F8F8"
      />
      <path
        d="M339.684 254.403c0 3.341 4.803 5.987 10.72 5.987 5.917 0 10.721-2.715 10.721-5.987 0-3.272-4.804-5.987-10.721-5.987-5.708 0-10.372 2.506-10.72 5.639v.348zm2.018 0v-.348c.279-2.506 4.038-4.525 8.633-4.525 4.733 0 8.632 2.158 8.632 4.803 0 2.646-3.899 4.873-8.632 4.873-4.734 0-8.633-2.088-8.633-4.803zM338.5 266.937v-.139-.07-.069-.139-.14-.139-.139-.07-.069V265.754c0-.07 0-.07.069-.139 0-.07 0-.07.07-.14v-.069c0-.07 0-.07.07-.139v-.07c0-.07 0-.07.069-.139 0-.07.07-.07.07-.14 0 0 0-.069.07-.069 0-.07.069-.07.069-.139v-.07l.07-.07c0-.069.069-.069.069-.139.07-.069.07-.139.14-.209 0-.069.069-.069.069-.139l.07-.07c0-.069.069-.069.069-.069l.07-.07.07-.069.069-.07.07-.07.07-.069.069-.07.07-.069s.069 0 .069-.07l.07-.07.07-.069 4.107-2.367 2.019 1.183-4.108 2.367c-.069.07-.139.07-.208.139-.07.07-.14.07-.209.14-.07.069-.139.139-.209.139l-.209.209-.209.209-.209.208c-.069.07-.069.14-.139.209 0 .07-.069.07-.069.139 0 .07-.07.07-.07.14v.069c-.07.07-.07.14-.139.209-.07.07-.07.209-.14.279-.069.069-.069.208-.139.278 0 .07-.069.209-.069.279 0 .069-.07.208-.07.278 0 .07-.07.209-.07.278v4.456h.14s.069 0 .069-.07l4.107-2.367 2.019 1.184-4.107 2.367h-.07l-1.949-1.114v2.367c0 .069 0 .139.07.208 0 .07.069.14.069.14 0 .069.07.139.07.139.07.07.07.139.139.209l.07.069c.07.07.139.14.209.14l-2.019-1.184c-.07-.069-.139-.069-.209-.139l-.07-.07c-.069-.069-.139-.139-.139-.209 0-.069-.069-.069-.069-.139 0-.069 0-.069-.07-.139v-.07-.139-.069-.07V272.924v-.139-5.917c.209.139.209.139.209.069z"
        fill="#F0F0F0"
      />
      <path
        d="M342.815 264.291c-1.253.696-2.297 2.506-2.297 3.968v5.778c0 1.462 1.044 2.019 2.297 1.322l4.107-2.367v-2.088l-4.107 2.367c-.279.139-.487 0-.487-.279v-5.777c0-.279.208-.697.487-.836l4.107-2.367v-2.088l-4.107 2.367z"
        fill="#F8F8F8"
      />
      <path
        d="M349.361 255.796c1.81-1.531 1.671-5.012-1.67-9.816-3.342-4.803.626-10.999.905-7.379.278 3.62 4.385 3.899 8.005 6.823 3.62 2.993-3.48 12.391-3.48 12.391s-5.57-.487-3.76-2.019z"
        fill="url(#paint88_linear_4171_3723)"
      />
      <path
        d="M342.19 241.737s3.411 1.462 3.69 4.943c.209 3.481-.836 6.892-.836 6.892s.279-3.69-.557-5.848c-.835-2.158-5.081-8.353-2.297-5.987z"
        fill="url(#paint89_linear_4171_3723)"
      />
      <path
        d="M29.621 135.705l132.267-72.398 1.392 192.135L33.868 322.9l-4.247-187.195z"
        fill="url(#paint90_linear_4171_3723)"
      />
      <path
        d="M20.015 416.668V125.263L.871 117.605v288.203l19.144 10.86zM156.947 334.108V46.114l-19.144-4.176v281.241l19.144 10.929z"
        fill="#DDD"
      />
      <path
        d="M.871 117.605l19.144 7.657 161.157-92.378-19.701-11.138-160.6 95.859z"
        fill="#F8F8F8"
      />
      <path
        d="M20.016 125.266v274.071l24.017-12.113V137.796l112.566-65.159v244.068l24.365-12.044V32.191L20.016 125.266z"
        fill="url(#paint91_linear_4171_3723)"
      />
      <path
        d="M251.691 400.101l68.918-40.445v41.002l-161.226 93.701c-1.184.696-2.994.696-4.177 0L20.016 416.67c-.558-.348-.836-.766-.836-1.184v-41.003c0 .418.278.836.835 1.184v-45.946l161.575-92.795 69.388 39.005v42.987l.713 81.183z"
        fill="#F8F8F8"
      />
      <path
        d="M19.18 374.48v41.003c0 .418.278.835.835 1.183l135.191 77.69c1.114.696 2.993.696 4.177 0v-41.003L87.68 412.281v-41.282l-61.26-45.04-7.24 3.69v44.831z"
        fill="#DDD"
      />
      <path
        d="M181.311 235.188l-161.297 93.7c-1.183.696-1.183 1.741 0 2.437l65.577 38.287c1.114.697 2.994.697 4.177 0l161.226-93.7-69.683-40.724z"
        fill="url(#paint92_linear_4171_3723)"
      />
      <path
        d="M250.926 318.93L89.63 412.63c-1.184.697-1.184 1.741 0 2.437l65.576 38.288c1.114.696 2.994.696 4.177 0l161.227-93.701-69.684-40.724z"
        fill="url(#paint93_linear_4171_3723)"
      />
      <path
        d="M336.411 256.489c-.069.069-14.062 28.959-14.688 30.143-1.741.556-15.385 3.48-31.953 4.664-17.752 1.253-25.131-.627-25.479-.836l18.865-39.192c.418.208 7.728 2.088 25.479.835 17.752-1.253 31.396-4.455 32.162-4.734l-4.386 9.12z"
        fill="url(#paint94_linear_4171_3723)"
      />
      <path
        d="M333.767 257.605c-.069.07-12.948 26.662-13.505 27.706-1.601.557-14.131 3.203-29.447 4.316-16.359 1.184-23.111-.556-23.46-.765l17.404-36.13c.348.139 7.101 1.949 23.46.766 16.359-1.184 28.959-4.108 29.586-4.316l-4.038 8.423z"
        fill="#F8F8F8"
      />
      <path
        d="M304.598 272.152l-1.67.139 7.24-14.967c.557-.07 1.113-.139 1.74-.209l-7.31 15.037z"
        fill="url(#paint95_linear_4171_3723)"
      />
      <path
        d="M317.824 280.436c-4.037.974-8.841 2.018-14.201 2.854l12.948-26.871a169.53 169.53 0 0014.202-2.855l-12.949 26.872z"
        fill="url(#paint96_linear_4171_3723)"
      />
      <path
        d="M296.037 277.157l-1.601.14 9.328-19.353c.557-.07 1.044-.07 1.601-.139l-9.328 19.352z"
        fill="url(#paint97_linear_4171_3723)"
      />
      <path
        d="M286.011 285.096a105.76 105.76 0 01-12.74-.209l12.949-26.871c3.55.278 7.796.417 12.739.208l-12.948 26.872z"
        fill="url(#paint98_linear_4171_3723)"
      />
      <path
        d="M289.284 284.953c-.557.07-1.114.07-1.671.07l12.949-26.871c.556 0 1.113-.07 1.67-.07l-12.948 26.871z"
        fill="url(#paint99_linear_4171_3723)"
      />
      <path
        d="M302.233 283.492c-.557.07-1.114.139-1.741.279L313.44 256.9c.557-.07 1.184-.14 1.741-.279l-12.948 26.871z"
        fill="url(#paint100_linear_4171_3723)"
      />
      <path
        d="M295.686 284.402l-1.67.209 12.948-26.871 1.671-.209-12.949 26.871z"
        fill="url(#paint101_linear_4171_3723)"
      />
      <path
        d="M332.861 290.104c-.139 0-23.32 22.277-24.225 23.112-1.81-.069-15.594-2.088-31.605-6.752-17.125-5.012-23.321-9.328-23.599-9.677l31.396-30.142c.278.278 6.543 4.664 23.599 9.676 17.125 5.012 30.978 6.752 31.744 6.752l-7.31 7.031z"
        fill="url(#paint102_linear_4171_3723)"
      />
      <path
        d="M330.006 290.175c-.139 0-21.441 20.467-22.346 21.302-1.671-.069-14.34-1.949-29.099-6.265-15.732-4.594-21.441-8.562-21.719-8.911l28.89-27.776c.278.279 5.987 4.247 21.719 8.911 15.733 4.595 28.542 6.265 29.238 6.265l-6.683 6.474z"
        fill="#F8F8F8"
      />
      <path
        d="M297.638 293.731l-1.601-.488 11.974-11.555 1.671.417-12.044 11.626z"
        fill="url(#paint103_linear_4171_3723)"
      />
      <path
        d="M307.106 306.121c-4.107-.487-8.98-1.183-14.34-2.297l21.51-20.676c5.361 1.114 10.234 1.81 14.341 2.298l-21.511 20.675z"
        fill="url(#paint104_linear_4171_3723)"
      />
      <path
        d="M287.823 295.401l-1.532-.418 15.454-14.897c.488.139 1.045.278 1.532.418l-15.454 14.897z"
        fill="url(#paint105_linear_4171_3723)"
      />
      <path
        d="M275.64 299.371c-4.733-1.532-8.632-3.133-11.904-4.664l21.511-20.676c3.272 1.532 7.17 3.133 11.904 4.664l-21.511 20.676z"
        fill="url(#paint106_linear_4171_3723)"
      />
      <path
        d="M278.841 300.348c-.557-.139-1.044-.348-1.601-.487l21.511-20.675c.487.139 1.044.348 1.601.487l-21.511 20.675z"
        fill="url(#paint107_linear_4171_3723)"
      />
      <path
        d="M291.372 303.543c-.557-.139-1.114-.209-1.671-.348l21.511-20.675c.557.139 1.114.278 1.671.348l-21.511 20.675z"
        fill="url(#paint108_linear_4171_3723)"
      />
      <path
        d="M284.968 302.085l-1.671-.417 21.511-20.676 1.67.418-21.51 20.675z"
        fill="url(#paint109_linear_4171_3723)"
      />
      <path
        d="M237.42 105.699v9.955c0 .07 0 .139.07.139 0 .07 0 .07.069.139 0 .07.07.07.07.14.069.069.069.139.139.139l.139.139-8.702-5.012c-.069 0-.139-.07-.139-.139l-.139-.14c0-.069-.07-.069-.07-.139v-.069-.14V100.826l8.563 4.873z"
        fill="url(#paint110_linear_4171_3723)"
      />
      <path
        d="M277 .562l-69.514 40.71c-.983.567-1.245 2.092-1.254 2.784l.209 67.943V112.487c.07 0 .07.069.07.069 0 .07.069.07.069.139l.14.14h.069c0 .069.07.139.14.139l8.701 5.012-.139-.139h-.069c-.07 0-.07-.07-.14-.139 0-.07-.069-.07-.069-.14-.07-.069-.07-.069-.07-.139-.07 0-.07-.069-.07-.139v-.418l-.208-67.943v-.418c.069-.07.069-.139.069-.209 0-.07.07-.139.07-.209 0-.07.069-.139.069-.208 0-.07.07-.14.07-.21 0-.069 0-.138.07-.208 0-.07.069-.14.069-.209v-.07l.07-.07c0-.069.07-.069.07-.138.069-.07.069-.14.139-.21.069-.069.069-.138.139-.208 0-.07.07-.14.139-.209 0-.07.07-.07.139-.14 0-.069.07-.069.14-.138 0-.07.069-.07.139-.14.069-.07.139-.07.209-.139l69.236-40.083c.069 0 .139-.07.208-.07.07 0 .14-.069.209-.069 0-.07.07-.07.14-.07l.417-.093s.068.042-8.423-4.85c-.07 0-.07-.069-.139-.069H277.139c0 .07-.07.07-.07.07H277z"
        fill="#8B30FF"
      />
      <path
        d="M216.466 45.48c-1.045.626-1.88 2.019-1.88 3.272l.209 67.943c0 1.184.835 1.671 1.879 1.044 3.69-2.158 10.443-6.126 15.246-8.91 3.202-1.81 5.499-3.133 5.499-3.063v9.537c0 1.322.905 1.601 1.88 1.044.487-.278.975-.766 1.323-1.462l9.258-16.707 35.712-20.606c1.045-.627 1.88-2.019 1.88-3.272l-.209-67.665c0-1.183-.835-1.67-1.879-1.044L216.466 45.48z"
        fill="#F8F8F8"
      />
      <path
        d="M271.462 35.871l-15.245 25.966-20.049-5.151.139 31.605 35.016-20.397.139-32.023z"
        fill="#8B30FF"
      />
      <path d="M237.004 54.462l18.378 5.221 15.454-25.34-33.832 20.12z" fill="#8B30FF" />
      <path
        d="M327.709 162.714l-9.049-41.072c-.418-2.089-2.158-3.62-3.76-3.481l-13.644 1.114c-.278 0-.487.07-.696.139l-1.044.418c.208-.07.417-.139.696-.139l13.644-1.114c1.601-.139 3.342 1.462 3.759 3.481l9.05 41.072c.418 1.74-.278 3.272-1.462 3.759l1.044-.418c1.184-.487 1.81-2.018 1.462-3.759z"
        fill="url(#paint111_linear_4171_3723)"
      />
      <path
        d="M313.857 118.577c1.601-.139 3.341 1.462 3.759 3.481l9.05 41.072c.417 2.088-.488 3.829-2.158 3.968l-13.645 1.114c-1.601.139-3.341-1.462-3.759-3.481l-9.05-41.072c-.417-2.089.488-3.829 2.158-3.968l13.645-1.114z"
        fill="#F8F8F8"
      />
      <path
        d="M310.864 137.866c-1.114-.766-2.228-.905-3.342-.278-.557.348-.905.835-.974 1.531 0 .139.069.348.069.488.139 0 .279-.07.418-.07.07 0 .139-.07.209-.139.139 0 .278 0 .348-.07-.348.487-.696.975-.975 1.532-.348.765-.209 1.601.209 2.366.278.488.418.488.696.07.905-1.392 2.089-2.506 3.62-3.202.209-.07.487-.07.696.069.905.557 1.532 1.323 2.089 2.228.209.418.348.418.626 0 .418-.626.348-1.671-.278-2.436-.139-.14-.209-.279-.348-.418h.626c.557.209 1.184.348 1.741.557.348.139.417-.07.417-.348-.069-.696-.417-1.253-.905-1.671-.557-.418-1.114-.627-1.81-.627.209-.139.348-.278.557-.417.488-.209 1.044-.418 1.532-.627.278-.139.209-.348 0-.557-.488-.557-1.114-.835-1.88-.905-1.462-.069-2.993 1.114-3.202 2.506-.07.14-.139.279-.139.418zm2.575 9.468c.14.209.348.278.488.417 0-.208 0-.487-.07-.626-.905-1.671-1.671-3.342-2.019-5.152-.069-.348-.069-.696-.209-1.044-.069-.139-.208-.209-.278-.348-.07.139-.139.279-.139.418.209 1.671.765 3.272 1.531 5.082.139.278.418.765.696 1.253z"
        fill="url(#paint112_linear_4171_3723)"
      />
      <path
        d="M310.863 137.867c.209.279.488.627.766.905.487-.905 1.323-1.392 2.367-1.392.209-.139.348-.278.557-.418-.209-.278-.139-.417.139-.557.279-.139.557-.278.905-.417-.557-.488-.975-.627-1.531-.557-1.184.069-2.019.766-2.507 1.81-.139.209-.208.418-.557.278a.536.536 0 00-.139.348z"
        fill="url(#paint113_linear_4171_3723)"
      />
      <path
        d="M314.483 139.607c-.07-.348.139-.418.418-.348.348.069.765.208 1.113.278-.069-.696-.696-1.323-1.601-1.531-.766-.209-2.019.139-2.227.835.556.278 1.113.487 1.74.766h.557z"
        fill="url(#paint114_linear_4171_3723)"
      />
      <path
        d="M307.591 139.327c.975-.766 2.019-1.044 3.341-.627-.139-.139-.208-.278-.348-.417-.905-.836-2.436-.836-3.202 0-.278.278-.487.626-.139 1.044.139.07.209 0 .348 0z"
        fill="url(#paint115_linear_4171_3723)"
      />
      <path
        d="M307.244 142.878c.974-1.462 2.227-2.576 3.828-3.272-.487-.696-1.74-.766-2.645-.139-1.323.765-1.81 2.158-1.183 3.411z"
        fill="url(#paint116_linear_4171_3723)"
      />
      <path
        d="M312.047 139.535c.696.766 1.462 1.462 2.158 2.228.209-.348.139-.975-.348-1.531-.487-.627-1.184-.905-1.81-.697z"
        fill="url(#paint117_linear_4171_3723)"
      />
      <path
        d="M312.534 186.177s14.131-.348 18.099-6.265c0 0-7.727-30.909-15.593-29.934-13.645 1.67-2.506 36.199-2.506 36.199z"
        fill="#F0F0F0"
      />
      <path
        d="M307.104 174.691s19.143-2.855 22.903-6.127l7.379 22.068s-16.22 7.797-20.815 4.873c-4.595-2.924-9.467-20.814-9.467-20.814z"
        fill="#2D5ACC"
      />
      <path
        d="M373.514 143.812a3.62 3.62 0 10-4.99-5.244 3.62 3.62 0 004.99 5.244z"
        fill="#353535"
      />
      <path
        d="M369.477 142.325a.557.557 0 10.001-1.113.557.557 0 00-.001 1.113z"
        fill="var(--text-color)"
      />
      <path
        d="M348.325 143.387a3.62 3.62 0 10-4.994-5.244 3.62 3.62 0 004.994 5.244z"
        fill="#353535"
      />
      <path
        d="M344.975 141.904a.558.558 0 100-1.116.558.558 0 000 1.116z"
        fill="var(--text-color)"
      />
      <path
        d="M360.776 161.81c1.81 0 3.341 1.114 4.037 2.646a4.988 4.988 0 00.418-2.019c0-2.576-2.019-4.734-4.455-4.734-2.437 0-4.456 2.089-4.456 4.734 0 .696.14 1.392.418 2.019.696-1.532 2.228-2.646 4.038-2.646z"
        fill="#353535"
      />
      <path
        d="M360.776 167.099c2.23 0 4.038-1.184 4.038-2.645s-1.808-2.645-4.038-2.645c-2.23 0-4.038 1.184-4.038 2.645s1.808 2.645 4.038 2.645z"
        fill="#AABBE7"
      />
      <path
        d="M232.408 157.426s23.878-19.144 32.719-10.233c5.43 5.43 9.189 28.542-4.247 31.953-13.435 3.411-28.472-21.72-28.472-21.72z"
        fill="#F0F0F0"
      />
      <path
        d="M242.71 158.402c1.114-4.594 15.107-8.353 18.03-5.29 2.924 3.063 6.823 12.739 1.741 18.517 0 0-20.536-10.024-19.771-13.227z"
        fill="#DEDEDE"
      />
      <path
        d="M235.4 244.235s20.258-4.455 31.744-7.309c11.486-2.855 10.303 9.258-2.367 20.048-12.67 10.86-43.648 1.393-43.648 1.393l14.271-14.132z"
        fill="#F0F0F0"
      />
      <path
        d="M220.155 231.355l29.517 3.62s-38.497 34.947-36.548 49.426c1.88 14.48-35.224 14.202-45.736 2.089s39.75-54.856 52.767-55.135z"
        fill="#2D5ACC"
      />
      <path
        d="M159.382 268.81c1.184-11.696-14.619-16.29-19.91-5.848-1.601 3.063-3.063 5.639-4.037 6.404-3.133 2.507-26.523-11.347-27.707 2.646-.905 10.929 11.556 16.081 17.056 17.751 1.601.488 3.272.627 4.873.349 7.101-1.184 27.846-5.987 29.656-20.746.069-.208.069-.348.069-.556zM192.38 272.917l4.107-.835c5.499-1.114 10.929 2.297 12.391 7.796l4.455 17.334c.627 2.367.418 4.804-.556 7.031-3.342 7.449-11.556 24.365-18.518 26.314-8.91 2.507-21.371-12.878-12.6-22.694 4.803-5.43 4.107-14.828 2.436-22.137-1.322-5.848 2.437-11.626 8.285-12.809z"
        fill="#F0F0F0"
      />
      <path
        d="M188.34 266.583c16.151 4.873 25.479 8.354 30.77 10.721 16.777-18.308 15.802-47.894 15.802-47.894s-4.385-50.053-62.096-26.593c-17.751 7.17-28.959 18.1-34.459 29.795 4.665 6.056 21.094 25.2 49.983 33.971z"
        fill="#2D5ACC"
      />
      <path
        d="M135.573 259.624l-2.088 4.107s-1.601 24.782 5.917 31.744c4.734 4.386 15.802-.627 23.738-7.518 3.62 1.322 7.588 2.227 11.835 2.854.417 5.43 1.81 10.233 5.36 11.625 0 0 26.314 1.045 32.231 5.639 3.551 2.785 2.298-12.67.766-25.409 2.158-1.601 4.107-3.411 5.917-5.36-5.29-2.437-14.619-5.848-30.769-10.721-28.96-8.771-45.319-27.915-49.983-33.972-4.316 8.911-5.152 18.378-2.924 27.011z"
        fill="#3056B9"
        stroke="#3056B9"
        strokeWidth={0.268198}
        strokeMiterlimit={10}
      />
      <path
        d="M254.754 238.528s-4.943 11.625-8.006 23.32c-3.063 11.696-36.617 3.133-36.617 3.133l-1.183-1.601-1.114-5.569s27.567-24.713 46.92-19.283z"
        fill="#2D5ACC"
      />
      <path
        d="M269.65 192.649c3.55-18.378-24.087-35.573-24.087-35.573h-.348a31.797 31.797 0 00-7.518-3.828c-22.834-8.424-49.426 3.689-57.014 22.763 0 .07-.07.14-.07.279-23.32 30.004 12.461 55.97 29.029 62.305 1.253.487 2.437.835 3.69 1.183l-.07.07h.279c5.221 1.253 10.372 1.113 15.245 0 11.626-.766 26.245-3.551 31.118-12.531 3.689-6.892 3.968-14.689 3.132-21.372 2.994-3.271 5.5-7.518 6.614-13.296z"
        fill="#F0F0F0"
      />
      <path
        d="M249.95 212.908a.827.827 0 01-.696-.836c0-.487.418-.835.905-.765.069 0 6.613.348 13.853-2.924.418-.209.905 0 1.114.417.209.418 0 .905-.418 1.114-7.588 3.481-14.34 3.133-14.619 3.063l-.139-.069zM252.246 219.247c-.766-.139-1.184-.278-1.253-.278-.418-.139-.696-.557-.627-.975.139-.417.557-.696.975-.626.069 0 6.474 1.601 14.131-.209a.76.76 0 01.975.626.76.76 0 01-.627.975c-6.056 1.462-11.277.905-13.574.487zM211.732 203.506c.417.139.835-.07 1.044-.418.209-.418 0-.905-.418-1.114-.069 0-6.056-2.784-10.86-9.05-.278-.348-.835-.417-1.183-.139-.348.279-.418.766-.139 1.184 5.151 6.613 11.277 9.397 11.486 9.537h.07zM206.789 208.101c.766.209 1.183.348 1.253.348a.76.76 0 00.975-.626.76.76 0 00-.627-.975c-.069 0-6.474-1.601-12.461-6.753a.866.866 0 00-1.183.07.865.865 0 00.069 1.183c4.804 4.108 9.677 5.987 11.974 6.753zM231.919 208.867c-3.69-2.228-8.145-.07-11.695 3.55-1.045 1.044-1.323 2.437-1.045 3.759 2.646-.696 6.614-1.114 9.677.696 2.297 1.393 3.341 3.62 3.898 5.709 5.43-.418 3.759-10.86-.835-13.714zM234.006 202.948l-2.367-.696c-.975-.279-2.019.348-2.297 1.392-.348 1.462-.418 3.411 1.74 3.968 1.949.557 3.202-.696 3.968-1.949.557-1.044.07-2.437-1.044-2.715z"
        fill="#353535"
      />
      <path
        d="M228.856 216.874c-3.063-1.879-6.961-1.392-9.676-.696.278 1.044.905 2.019 1.949 2.576 2.993 1.67 7.17 3.55 10.72 3.898h.836c-.487-2.158-1.532-4.386-3.829-5.778z"
        fill="#AABBE7"
      />
      <path
        d="M183.19 176.848s-8.215-29.447 3.481-34.111c7.1-2.854 29.864 2.785 27.706 16.499-2.088 13.644-31.187 17.612-31.187 17.612z"
        fill="#F0F0F0"
      />
      <path
        d="M188.203 167.798c-3.76-2.785-1.741-17.195 2.227-18.657 3.968-1.461 14.41-1.253 17.682 5.639 0 0-17.264 14.967-19.909 13.018z"
        fill="#DEDEDE"
      />
      <path
        d="M248.011 203.104a3.62 3.62 0 10-3.341-6.424 3.62 3.62 0 003.341 6.424z"
        fill="#353535"
      />
      <path
        d="M248.644 199.737a1.393 1.393 0 10-2.785-.057 1.393 1.393 0 002.785.057z"
        fill="var(--text-color)"
      />
      <path
        d="M222.11 196.557a3.62 3.62 0 10-3.338-6.423 3.62 3.62 0 003.338 6.423z"
        fill="#353535"
      />
      <path
        d="M222.717 193.233a1.392 1.392 0 10-2.783-.057 1.392 1.392 0 002.783.057z"
        fill="var(--text-color)"
      />
      <path
        d="M215.7 251.264l.348.07 4.246-7.797c-4.594.835-13.505-2.924-13.505-2.924.07 2.298 1.392 8.772 1.392 8.772l.975.209c1.253 7.936 7.588 21.093 5.917 28.263-.557 2.297 6.335 6.822 6.335 6.822l3.62-5.917c-4.595-7.101-8.911-19.771-9.328-27.498z"
        fill="#353535"
      />
      <path
        opacity={0.2}
        d="M166.413 322.271c-2.924 6.196-9.328 10.651-28.612 1.532-19.283-9.119-32.509-21.58-29.586-27.776 2.924-6.196 20.954-3.759 40.237 5.36 19.214 9.189 20.885 14.689 17.961 20.884zM195.722 359.24c-2.923 6.196-7.588 11.486-17.264 6.892-9.676-4.595-15.176-13.366-12.182-19.562 2.923-6.195 13.157-7.448 22.833-2.854 9.676 4.595 9.607 9.329 6.613 15.524z"
        fill="#F8F8F8"
      />
      <path
        d="M197.53 236.438s-12.391 11.764-13.018 14.549c-.626 2.784 8.075 12.67 23.808-3.411l-10.79-11.138z"
        fill="#F8F8F8"
      />
      <path
        d="M181.449 222.727s13.575 17.333 19.005 27.288c5.43 9.955-5.709 14.341-17.056 7.936-11.347-6.404-21.232-23.251-21.232-23.251l19.283-11.973zM206.233 242.77c.348.069.696.139 1.045.348a24.822 24.822 0 00-1.81-2.506c-2.785-3.272-6.266-5.152-7.728-4.316-1.462.835-.348 4.176 2.437 7.379.418.487.835.905 1.253 1.322 1.114-.974 3.063-2.436 4.803-2.227z"
        fill="#F0F0F0"
      />
      <path
        d="M207.138 248.271c.07 0 .209 0 .278-.07h.07c.139 0 .209-.069.278-.139a.545.545 0 00.279-.278l.069-.07c.14-.209.209-.418.209-.627v-.139-.348-.278c0-.07 0-.209-.069-.348 0-.07-.07-.209-.07-.348 0-.14-.07-.209-.07-.348-.069-.14-.069-.279-.139-.418-.069-.07-.069-.209-.139-.279-.07-.139-.139-.348-.209-.487-.069-.07-.069-.209-.139-.278a7.555 7.555 0 00-.418-.766c-.348-.209-.696-.279-1.044-.348-1.671-.209-3.62 1.253-4.803 2.227 1.67 1.602 3.48 2.785 4.803 3.133.348.07.627.139.905.139l.209.07z"
        fill="#945831"
      />
      <path
        d="M219.461 253.909c-2.437-2.018-1.184-4.037.069-6.335 1.253-2.297-5.569-.348-6.822 0-1.044.279-3.202-3.271-5.43-4.455.139.279.279.557.418.766.069.07.069.209.139.278.07.14.139.348.209.488.069.139.069.208.139.278.07.139.07.279.139.418 0 .139.07.209.07.348 0 .139.069.209.069.348 0 .139.07.209.07.348v.766c-.07.278-.139.487-.209.626 0 .07-.069.07-.069.07-.07.07-.14.209-.279.278-.069.07-.209.07-.278.14h-.07c-.07 0-.209.069-.278.069h-.07c-.278 0-.557 0-.905-.139a6.35 6.35 0 001.392 2.436c.557.697 1.323 1.254 2.367 1.671.696.975 2.228 2.019 3.551 1.671 1.67-.487 1.67 3.968 5.151 6.126 3.272 2.088 3.063-4.107.627-6.196zM225.876 256.053c.366-.395-.045-1.372-.919-2.182-.874-.811-1.879-1.148-2.245-.754-.366.395.045 1.372.919 2.183.874.81 1.879 1.147 2.245.753zM213.588 258.914c.401-.136.515-.866.256-1.631-.26-.764-.795-1.274-1.195-1.138-.401.136-.515.865-.256 1.63.26.765.795 1.274 1.195 1.139z"
        fill="#A9653A"
      />
      <path
        d="M445.985 85.448v7.728c0 .069 0 .069-.07.069 0 .07-.069.07-.069.07 0 .069-.07.069-.07.139-.07 0-.07.07-.139.07l6.613-3.83c.07 0 .07-.07.139-.07.07-.069.07-.069.07-.138l.07-.07v-.07V89.137 81.62l-6.544 3.829z"
        fill="url(#paint118_linear_4171_3723)"
      />
      <path
        d="M470.073 37.936c0-.07 0-.07 0 0v-.627-.14-.139s0-.069-.07-.069v-.07s.001-.07-.069-.07v-.069s0-.07-.07-.07l-.069-.07c0-.069-.07-.069-.07-.138l-.07-.07-.069-.07-.07-.07-.069-.069-.07-.07-.07-.069-.069-.07s-.07 0-.07-.07h-.069s-.07 0-.07-.069c0 0-.07 0-.07-.07L415.635 5.427h-.139H415.287 415.078h-.279c-.069 0-.069 0-.139.07l-6.613 3.828s.069-.07.139-.07H408.673c.07 0 .07 0 .14.07.069 0 .069 0 .139.07.069 0 .069.07.139.07l11.051 45.475c.07 0 .07.07.14.07.069 0 .069.07.139.07.069 0 .069.07.139.139l.139.14.139.138.14.14c0 .07.069.07.069.139l.07.07s0 .069.07.069v.07c0 .07.069.07.069.139 0 .07.07.14.07.14 0 .069.069.138.069.138 0 .07.07.14.07.14 0 .07 0 .139.07.139V57.097l41.609 36.837V94.352c0 .07 0 .07-.069.07 0 .07-.07.07-.07.07 0 .069-.07.069-.07.138-.069 0-.069.07-.139.07l6.72-3.788c.07 0 .07-.07.139-.07.07-.07.07-.07.07-.139l.07-.07v-.07V90.356 90.146l.278-52.21z"
        fill="url(#paint119_linear_4171_3723)"
      />
      <path
        d="M461.996 39.426c.766.487 1.462 1.531 1.462 2.506l-.14 51.793c0 .905-.626 1.253-1.461.835-2.785-1.67-8.006-4.664-11.626-6.822-2.437-1.392-4.177-2.367-4.177-2.297v7.309c0 .975-.696 1.253-1.462.835a2.715 2.715 0 01-1.044-1.113l-7.031-12.74L409.298 64c-.766-.487-1.462-1.531-1.462-2.506l.139-51.584c0-.905.627-1.253 1.462-.835l52.559 30.352z"
        fill="#F8F8F8"
      />
      <path
        d="M439.51 56.339c0-4.664-3.272-10.372-7.379-12.74-.766-.487-1.393-1.53-1.393-2.436 0-.905.627-1.253 1.462-.835 5.639 3.272 10.233 11.138 10.164 17.612 0 .905-.627 1.253-1.392.836-.836-.418-1.462-1.532-1.462-2.437zM439.579 61.072l3.76 6.543c.765 1.323.696 2.715-.07 3.202l-1.114.627c-.487.14-1.044.14-1.601.07a4.708 4.708 0 01-1.601-.488c-.07 0-.209-.07-.487-.209-1.532-.904-6.614-4.385-12.67-14.897-5.152-8.91-7.031-14.41-6.544-18.865a6.03 6.03 0 01.418-1.602c.209-.556.557-.974.905-1.253l1.044-.696c.418-.209.905-.139 1.462.14.487.278.974.765 1.322 1.392l3.76 6.544c.348.556.487 1.183.557 1.67 0 .348 0 .696-.14.975-.209.766-.835 1.74-2.367 1.601 0 .348.697 7.24 8.493 14.688.14-.556.905-2.227 3.272-.974l.07.07c.626.348 1.114.835 1.531 1.462z"
        fill="#8434FF"
      />
      <path
        d="M443.132 45.834c3.132 5.36 4.803 11.138 4.803 16.15 0 .905-.626 1.253-1.392.836-.766-.488-1.392-1.532-1.392-2.437 0-8.632-6.057-19.144-13.575-23.53-.766-.487-1.392-1.531-1.392-2.436s.626-1.253 1.462-.835c4.316 2.506 8.423 6.822 11.486 12.252z"
        fill="#8434FF"
      />
      <path
        d="M634.15 282.381c0 .766-.487 1.531-1.531 2.088l-53.812 31.118c-2.019 1.114-5.221 1.114-7.17 0l-53.464-31.118c-.975-.557-1.462-1.322-1.462-2.088l.07 50.261c0 .766.487 1.462 1.461 2.089l53.464 31.117c1.949 1.114 5.221 1.114 7.17 0l53.812-31.117c.975-.557 1.532-1.323 1.532-2.089l-.07-50.261z"
        fill="#F8F8F8"
      />
      <path
        d="M571.983 249.244c2.018-1.114 5.221-1.114 7.17 0l53.464 31.117c1.949 1.114 1.949 2.994 0 4.177l-53.812 31.117c-2.019 1.114-5.221 1.114-7.17 0l-53.464-31.117c-1.949-1.114-1.949-2.993 0-4.177l53.812-31.117z"
        fill="url(#paint120_linear_4171_3723)"
      />
      <path
        d="M533.906 340.859c0 .766-.487 1.532-1.532 2.089l-53.811 31.117c-2.019 1.114-5.221 1.114-7.171 0l-53.463-31.117c-.975-.557-1.462-1.323-1.462-2.089l.069 50.262c0 .766.488 1.462 1.462 2.088l53.464 31.118c1.949 1.114 5.221 1.114 7.17 0l53.812-31.118c.975-.557 1.532-1.322 1.532-2.088l-.07-50.262z"
        fill="#F8F8F8"
      />
      <path
        d="M471.74 307.734c2.019-1.114 5.222-1.114 7.171 0l53.463 31.117c1.95 1.114 1.95 2.994 0 4.177l-53.811 31.048c-2.019 1.114-5.221 1.114-7.171 0l-53.463-31.117c-1.95-1.114-1.95-2.994 0-4.177l53.811-31.048z"
        fill="url(#paint121_linear_4171_3723)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4171_3723"
          x1={-11.1659}
          y1={238.663}
          x2={583.82}
          y2={229.219}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4171_3723"
          x1={300.158}
          y1={177.913}
          x2={366.518}
          y2={216.382}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4171_3723"
          x1={260.14}
          y1={173.533}
          x2={358.024}
          y2={207.728}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4171_3723"
          x1={258.568}
          y1={178.042}
          x2={356.451}
          y2={212.237}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4171_3723"
          x1={270.608}
          y1={143.571}
          x2={368.491}
          y2={177.766}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4171_3723"
          x1={268.216}
          y1={150.421}
          x2={366.099}
          y2={184.616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4171_3723"
          x1={270.138}
          y1={144.919}
          x2={368.02}
          y2={179.114}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4171_3723"
          x1={270.868}
          y1={142.828}
          x2={368.751}
          y2={177.023}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4171_3723"
          x1={270.184}
          y1={144.782}
          x2={368.067}
          y2={178.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4171_3723"
          x1={271.323}
          y1={141.523}
          x2={369.205}
          y2={175.718}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_4171_3723"
          x1={268.258}
          y1={150.297}
          x2={366.142}
          y2={184.492}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_4171_3723"
          x1={269.165}
          y1={147.704}
          x2={367.048}
          y2={181.899}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_4171_3723"
          x1={270.13}
          y1={144.943}
          x2={368.013}
          y2={179.137}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_4171_3723"
          x1={267.726}
          y1={151.822}
          x2={365.608}
          y2={186.017}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_4171_3723"
          x1={250.479}
          y1={201.191}
          x2={348.362}
          y2={235.386}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_4171_3723"
          x1={248.476}
          y1={206.926}
          x2={346.359}
          y2={241.121}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_4171_3723"
          x1={250.399}
          y1={201.418}
          x2={348.282}
          y2={235.613}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_4171_3723"
          x1={248.558}
          y1={206.694}
          x2={346.441}
          y2={240.888}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_4171_3723"
          x1={246.55}
          y1={212.442}
          x2={344.433}
          y2={246.637}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_4171_3723"
          x1={246.357}
          y1={212.99}
          x2={344.24}
          y2={247.185}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_4171_3723"
          x1={245.61}
          y1={215.126}
          x2={343.493}
          y2={249.321}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_4171_3723"
          x1={266.76}
          y1={154.588}
          x2={364.642}
          y2={188.783}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_4171_3723"
          x1={254.326}
          y1={190.175}
          x2={352.209}
          y2={224.371}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_4171_3723"
          x1={254.801}
          y1={188.821}
          x2={352.684}
          y2={223.016}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_4171_3723"
          x1={252.4}
          y1={195.697}
          x2={350.284}
          y2={229.892}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_4171_3723"
          x1={265.861}
          y1={157.163}
          x2={363.744}
          y2={191.358}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_4171_3723"
          x1={263.933}
          y1={162.677}
          x2={361.816}
          y2={196.872}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_4171_3723"
          x1={264.421}
          y1={161.289}
          x2={362.303}
          y2={195.484}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_4171_3723"
          x1={262.012}
          y1={168.174}
          x2={359.895}
          y2={202.369}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_4171_3723"
          x1={262.491}
          y1={166.805}
          x2={360.374}
          y2={201}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_4171_3723"
          x1={263.398}
          y1={164.21}
          x2={361.281}
          y2={198.405}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_4171_3723"
          x1={260.093}
          y1={173.665}
          x2={357.976}
          y2={207.86}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_4171_3723"
          x1={260.569}
          y1={172.304}
          x2={358.452}
          y2={206.499}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_4171_3723"
          x1={261.471}
          y1={169.721}
          x2={359.355}
          y2={203.916}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_4171_3723"
          x1={258.166}
          y1={179.184}
          x2={356.049}
          y2={213.379}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_4171_3723"
          x1={261.958}
          y1={168.33}
          x2={359.841}
          y2={202.525}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_4171_3723"
          x1={258.65}
          y1={177.799}
          x2={356.532}
          y2={211.994}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_4171_3723"
          x1={262.451}
          y1={166.922}
          x2={360.333}
          y2={201.116}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_4171_3723"
          x1={259.551}
          y1={175.223}
          x2={357.433}
          y2={209.417}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_4171_3723"
          x1={260.037}
          y1={173.829}
          x2={357.92}
          y2={208.024}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_4171_3723"
          x1={256.722}
          y1={183.318}
          x2={354.605}
          y2={217.513}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_4171_3723"
          x1={260.526}
          y1={172.435}
          x2={358.409}
          y2={206.63}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_4171_3723"
          x1={257.628}
          y1={180.719}
          x2={355.512}
          y2={214.914}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_4171_3723"
          x1={258.112}
          y1={179.346}
          x2={355.995}
          y2={213.541}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_4171_3723"
          x1={258.605}
          y1={177.935}
          x2={356.487}
          y2={212.13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_4171_3723"
          x1={255.709}
          y1={186.22}
          x2={353.592}
          y2={220.415}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_4171_3723"
          x1={256.191}
          y1={184.837}
          x2={354.074}
          y2={219.032}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_4171_3723"
          x1={252.882}
          y1={194.315}
          x2={350.765}
          y2={228.509}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_4171_3723"
          x1={256.683}
          y1={183.435}
          x2={354.566}
          y2={217.63}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_4171_3723"
          x1={253.786}
          y1={191.726}
          x2={351.668}
          y2={225.921}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_4171_3723"
          x1={254.271}
          y1={190.333}
          x2={352.154}
          y2={224.528}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_4171_3723"
          x1={250.959}
          y1={199.819}
          x2={348.842}
          y2={234.013}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_4171_3723"
          x1={254.761}
          y1={188.933}
          x2={352.643}
          y2={223.128}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_4171_3723"
          x1={251.864}
          y1={197.226}
          x2={349.746}
          y2={231.421}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_4171_3723"
          x1={252.346}
          y1={195.85}
          x2={350.228}
          y2={230.045}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_4171_3723"
          x1={249.035}
          y1={205.325}
          x2={346.918}
          y2={239.519}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_4171_3723"
          x1={252.835}
          y1={194.446}
          x2={350.718}
          y2={228.641}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_4171_3723"
          x1={249.945}
          y1={202.723}
          x2={347.828}
          y2={236.917}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_4171_3723"
          x1={250.421}
          y1={201.349}
          x2={348.305}
          y2={235.544}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_4171_3723"
          x1={250.915}
          y1={199.944}
          x2={348.799}
          y2={234.138}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_4171_3723"
          x1={248.014}
          y1={208.247}
          x2={345.896}
          y2={242.442}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_4171_3723"
          x1={248.502}
          y1={206.853}
          x2={346.386}
          y2={241.048}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_4171_3723"
          x1={246.334}
          y1={213.052}
          x2={344.217}
          y2={247.247}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_4171_3723"
          x1={248.994}
          y1={205.438}
          x2={346.877}
          y2={239.633}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_4171_3723"
          x1={244.654}
          y1={217.864}
          x2={342.537}
          y2={252.059}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_4171_3723"
          x1={246.579}
          y1={212.355}
          x2={344.462}
          y2={246.55}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_4171_3723"
          x1={247.067}
          y1={210.963}
          x2={344.95}
          y2={245.157}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_4171_3723"
          x1={244.664}
          y1={217.842}
          x2={342.546}
          y2={252.037}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_4171_3723"
          x1={264.563}
          y1={160.88}
          x2={362.446}
          y2={195.075}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_4171_3723"
          x1={252.586}
          y1={195.154}
          x2={350.469}
          y2={229.349}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_4171_3723"
          x1={264.37}
          y1={161.426}
          x2={362.253}
          y2={195.621}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_4171_3723"
          x1={266.291}
          y1={155.933}
          x2={364.174}
          y2={190.128}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_4171_3723"
          x1={263.879}
          y1={162.838}
          x2={361.762}
          y2={197.033}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_4171_3723"
          x1={267.241}
          y1={153.215}
          x2={365.124}
          y2={187.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_4171_3723"
          x1={265.319}
          y1={158.713}
          x2={363.202}
          y2={192.908}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_4171_3723"
          x1={265.803}
          y1={157.33}
          x2={363.685}
          y2={191.525}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_4171_3723"
          x1={256.245}
          y1={184.683}
          x2={354.129}
          y2={218.878}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_4171_3723"
          x1={267.784}
          y1={151.657}
          x2={365.666}
          y2={185.852}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_4171_3723"
          x1={268.686}
          y1={149.071}
          x2={366.569}
          y2={183.266}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_4171_3723"
          x1={266.337}
          y1={155.793}
          x2={364.22}
          y2={189.988}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_4171_3723"
          x1={272.526}
          y1={138.08}
          x2={370.408}
          y2={172.275}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_4171_3723"
          x1={478.049}
          y1={206.482}
          x2={373.997}
          y2={206.482}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_4171_3723"
          x1={410.703}
          y1={181.555}
          x2={427.398}
          y2={202.47}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_4171_3723"
          x1={419.476}
          y1={177.784}
          x2={449.971}
          y2={223.57}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_4171_3723"
          x1={417.906}
          y1={178.25}
          x2={449.153}
          y2={225.165}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_4171_3723"
          x1={411.06}
          y1={183.007}
          x2={442.147}
          y2={229.682}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_4171_3723"
          x1={408.256}
          y1={185.239}
          x2={439.042}
          y2={231.463}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint87_linear_4171_3723"
          x1={414.811}
          y1={179.972}
          x2={446.454}
          y2={227.481}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_4171_3723"
          x1={352.005}
          y1={240.76}
          x2={352.005}
          y2={250.592}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset={1} stopColor="#F0F0F0" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint89_linear_4171_3723"
          x1={343.574}
          y1={243.199}
          x2={343.574}
          y2={249.166}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0" />
          <stop offset={1} stopColor="#F0F0F0" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint90_linear_4171_3723"
          x1={48.1307}
          y1={368.64}
          x2={134.452}
          y2={59.5528}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={0.5722} stopColor="#8B30FF" />
          <stop offset={0.9118} stopColor="#DEDEDE" />
        </linearGradient>
        <linearGradient
          id="paint91_linear_4171_3723"
          x1={20.0405}
          y1={215.767}
          x2={180.93}
          y2={215.767}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_4171_3723"
          x1={-276.06}
          y1={309.14}
          x2={321.74}
          y2={299.651}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint93_linear_4171_3723"
          x1={-206.444}
          y1={392.905}
          x2={391.355}
          y2={383.416}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_4171_3723"
          x1={301.349}
          y1={249.849}
          x2={304.361}
          y2={290.147}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_4171_3723"
          x1={328.482}
          y1={263.084}
          x2={251.169}
          y2={268.864}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_4171_3723"
          x1={328.814}
          y1={267.542}
          x2={251.501}
          y2={273.322}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_4171_3723"
          x1={328.652}
          y1={265.35}
          x2={251.339}
          y2={271.13}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint98_linear_4171_3723"
          x1={328.873}
          y1={268.322}
          x2={251.56}
          y2={274.102}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_4171_3723"
          x1={328.922}
          y1={268.953}
          x2={251.609}
          y2={274.733}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint100_linear_4171_3723"
          x1={328.895}
          y1={268.593}
          x2={251.582}
          y2={274.373}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint101_linear_4171_3723"
          x1={328.916}
          y1={268.915}
          x2={251.603}
          y2={274.695}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint102_linear_4171_3723"
          x1={302.184}
          y1={271.37}
          x2={290.954}
          y2={310.188}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint103_linear_4171_3723"
          x1={322.999}
          y1={293.242}
          x2={248.523}
          y2={271.696}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint104_linear_4171_3723"
          x1={321.757}
          y1={297.536}
          x2={247.281}
          y2={275.991}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint105_linear_4171_3723"
          x1={322.365}
          y1={295.431}
          x2={247.89}
          y2={273.885}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint106_linear_4171_3723"
          x1={321.538}
          y1={298.294}
          x2={247.062}
          y2={276.748}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint107_linear_4171_3723"
          x1={321.36}
          y1={298.908}
          x2={246.884}
          y2={277.362}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint108_linear_4171_3723"
          x1={321.461}
          y1={298.552}
          x2={246.985}
          y2={277.006}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint109_linear_4171_3723"
          x1={321.372}
          y1={298.862}
          x2={246.897}
          y2={277.316}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint110_linear_4171_3723"
          x1={233.39}
          y1={-25.854}
          x2={233.39}
          y2={71.1886}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint111_linear_4171_3723"
          x1={301.484}
          y1={144.035}
          x2={326.039}
          y2={142.05}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint112_linear_4171_3723"
          x1={302.586}
          y1={131.746}
          x2={311.489}
          y2={139.087}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint113_linear_4171_3723"
          x1={305.952}
          y1={129.376}
          x2={322.887}
          y2={145.986}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint114_linear_4171_3723"
          x1={305.33}
          y1={129.712}
          x2={322.683}
          y2={146.731}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint115_linear_4171_3723"
          x1={302.865}
          y1={132.325}
          x2={320.129}
          y2={149.258}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint116_linear_4171_3723"
          x1={301.881}
          y1={133.517}
          x2={318.978}
          y2={150.286}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint117_linear_4171_3723"
          x1={304.178}
          y1={130.711}
          x2={321.75}
          y2={147.946}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint118_linear_4171_3723"
          x1={449.111}
          y1={-14.9444}
          x2={449.111}
          y2={59.082}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint119_linear_4171_3723"
          x1={439.218}
          y1={-15.0494}
          x2={439.218}
          y2={58.977}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint120_linear_4171_3723"
          x1={367.839}
          y1={285.714}
          x2={669.645}
          y2={280.923}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
        <linearGradient
          id="paint121_linear_4171_3723"
          x1={267.597}
          y1={344.204}
          x2={569.403}
          y2={339.414}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#306AFF" />
          <stop offset={1} stopColor="#8B30FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgComponent;
